/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

export type Ability = {
  __typename?: 'Ability';
  action: Array<Scalars['String']['output']>;
  /** IDs of the records the rule is limited to. For the WpBlog and Site subjects these are platform site IDs, not Site IDs. */
  limitingIds?: Maybe<Array<Scalars['Int']['output']>>;
  subject: Array<Scalars['String']['output']>;
};

export type Account = {
  __typename?: 'Account';
  accountType?: Maybe<Scalars['String']['output']>;
  agency?: Maybe<Agency>;
  business?: Maybe<BusinessOnboarding>;
  businessOnboarding?: Maybe<BusinessOnboarding>;
  campaigns?: Maybe<Array<Campaign>>;
  clientAccounts?: Maybe<Array<Account>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  featurePermissions: Array<FeaturePermission>;
  id: Scalars['Int']['output'];
  isAgency: Scalars['Boolean']['output'];
  marketingStrategies: Array<MarketingStrategy>;
  name: Scalars['String']['output'];
  onboardingStatus?: Maybe<OnboardingStatus>;
  owner: User;
  paySubscription?: Maybe<PaySubscription>;
  paySubscriptionId?: Maybe<Scalars['Int']['output']>;
  serviceOrders: Array<ServiceOrderGraph>;
  sites?: Maybe<Array<Site>>;
  teamMembers?: Maybe<Array<TeamMember>>;
  twilioSubaccount?: Maybe<TwilioSubaccount>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use sites. */
  wpBlogs?: Maybe<Array<WpBlog>>;
};


export type AccountSitesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountWpBlogsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountCreated = {
  __typename?: 'AccountCreated';
  accountId: Scalars['Int']['output'];
  id?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AccountCreation */
export type AccountCreationInput = {
  carrotVersion?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  /** @deprecated Use carrotVersion instead */
  isNewCarrot?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  turnstileFailureContext?: InputMaybe<Scalars['String']['input']>;
  turnstileToken?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountCreation. */
export type AccountCreationPayload = {
  __typename?: 'AccountCreationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  user?: Maybe<AccountCreated>;
};

export type ActionItem = {
  __typename?: 'ActionItem';
  actionType?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDismissible: Scalars['Boolean']['output'];
  priority: ActionItemPriority;
  site: Site;
  siteId: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use site. */
  wpBlog: WpBlog;
  /** @deprecated Use siteId. */
  wpBlogId: Scalars['Int']['output'];
};

/** Autogenerated input type of ActionItemDismiss */
export type ActionItemDismissInput = {
  actionItemId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ActionItemDismiss. */
export type ActionItemDismissPayload = {
  __typename?: 'ActionItemDismissPayload';
  actionItem?: Maybe<ActionItem>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum ActionItemPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Highest = 'HIGHEST',
  Low = 'LOW',
  Lowest = 'LOWEST',
  Medium = 'MEDIUM'
}

export type ActionItemTemplate = {
  __typename?: 'ActionItemTemplate';
  actionType: Scalars['String']['output'];
  actionUrlTemplate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isDismissible: Scalars['Boolean']['output'];
  priority: ActionItemPriority;
  title: Scalars['String']['output'];
  trigger: ActionItemTrigger;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ActionItemTemplateUpsert */
export type ActionItemTemplateUpsertInput = {
  actionType: Scalars['String']['input'];
  actionUrlTemplate?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDismissible?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<ActionItemPriority>;
  title?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<ActionItemTrigger>;
};

/** Autogenerated return type of ActionItemTemplateUpsert. */
export type ActionItemTemplateUpsertPayload = {
  __typename?: 'ActionItemTemplateUpsertPayload';
  actionItemTemplate?: Maybe<ActionItemTemplate>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Trigger events for action item templates */
export enum ActionItemTrigger {
  DnsCheckFailed = 'DNS_CHECK_FAILED',
  DomainMapped = 'DOMAIN_MAPPED',
  ServicePurchased = 'SERVICE_PURCHASED',
  WpBlogCreated = 'WP_BLOG_CREATED'
}

/** Autogenerated input type of ActiveAccountUpdate */
export type ActiveAccountUpdateInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ActiveAccountUpdate. */
export type ActiveAccountUpdatePayload = {
  __typename?: 'ActiveAccountUpdatePayload';
  activeAccount?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of AddClient */
export type AddClientInput = {
  /** The agency account ID */
  accountId: Scalars['Int']['input'];
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientName: Scalars['String']['input'];
};

/** Autogenerated return type of AddClient. */
export type AddClientPayload = {
  __typename?: 'AddClientPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
};

/** Autogenerated input type of AddPriceToSubscription */
export type AddPriceToSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productName: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AddPriceToSubscription. */
export type AddPriceToSubscriptionPayload = {
  __typename?: 'AddPriceToSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Agency = {
  __typename?: 'Agency';
  account: Account;
  clientAccounts: Array<Account>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
};

export type AgencyBillingUsage = {
  __typename?: 'AgencyBillingUsage';
  /**
   * Client sites that count toward billing: active with a domain mapped
   * @deprecated Renamed to countableSites — it counts mapped, billable sites, not every active one.
   */
  activeSites: Scalars['Int']['output'];
  /** Client sites that count toward billing: active with a domain mapped */
  countableSites: Scalars['Int']['output'];
  /** Number of sites included in the plan */
  includedSites: Scalars['Int']['output'];
  /** Number of sites over the included limit */
  overageSites: Scalars['Int']['output'];
};

export type AuditCampaign = {
  __typename?: 'AuditCampaign';
  allow?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Int']['output']>;
  blockedDelta?: Maybe<Scalars['Int']['output']>;
  broken?: Maybe<Scalars['Int']['output']>;
  brokenDelta?: Maybe<Scalars['Int']['output']>;
  crawlSubdomains?: Maybe<Scalars['Boolean']['output']>;
  crawledPages?: Maybe<Scalars['Int']['output']>;
  crawledPagesDelta?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  disallow?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  haveIssues?: Maybe<Scalars['Int']['output']>;
  haveIssuesDelta?: Maybe<Scalars['Int']['output']>;
  healthy?: Maybe<Scalars['Int']['output']>;
  healthyDelta?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastAudit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextAudit?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notify?: Maybe<Scalars['Boolean']['output']>;
  pageLimit?: Maybe<Scalars['Int']['output']>;
  pagesCrawled?: Maybe<Scalars['Int']['output']>;
  pagesCrawledDelta?: Maybe<Scalars['Int']['output']>;
  redirected?: Maybe<Scalars['Int']['output']>;
  redirectedDelta?: Maybe<Scalars['Int']['output']>;
  removedParameters?: Maybe<Scalars['String']['output']>;
  respectCrawlDelay?: Maybe<Scalars['Boolean']['output']>;
  scheduleDay?: Maybe<Scalars['Int']['output']>;
  seoProjectId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userAgentType?: Maybe<Scalars['Int']['output']>;
};

export type AuditSnapshot = {
  __typename?: 'AuditSnapshot';
  auditCampaignId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  errorCount: Scalars['Int']['output'];
  errorDelta?: Maybe<Scalars['Int']['output']>;
  failures?: Maybe<Scalars['JSON']['output']>;
  finishDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  formattedErrors: Array<AuditSnapshotFormattedIssue>;
  formattedNotices: Array<AuditSnapshotFormattedIssue>;
  formattedWarnings: Array<AuditSnapshotFormattedIssue>;
  health: Scalars['Int']['output'];
  healthDelta: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  newErrors?: Maybe<Scalars['JSON']['output']>;
  noticeCount: Scalars['Int']['output'];
  noticeDelta?: Maybe<Scalars['Int']['output']>;
  notices?: Maybe<Scalars['JSON']['output']>;
  pagesCrawled?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<Scalars['JSON']['output']>;
  snapshotId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  warningCount: Scalars['Int']['output'];
  warningDelta?: Maybe<Scalars['Int']['output']>;
  warnings?: Maybe<Scalars['JSON']['output']>;
};

export type AuditSnapshotFormattedIssue = {
  __typename?: 'AuditSnapshotFormattedIssue';
  checks: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  delta: Scalars['Int']['output'];
  details: Array<AuditSnapshotFormattedIssueDetail>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  infoColumn: Scalars['String']['output'];
  issueId: Scalars['String']['output'];
  new: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  titlePage: Scalars['String']['output'];
  urlColumn: Scalars['String']['output'];
};

export type AuditSnapshotFormattedIssueDetail = {
  __typename?: 'AuditSnapshotFormattedIssueDetail';
  discovered: Scalars['ISO8601DateTime']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  info?: Maybe<Scalars['JSON']['output']>;
  num: Scalars['Int']['output'];
  pageId: Scalars['String']['output'];
  sourceUrl: Scalars['String']['output'];
  targetUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Backlink = {
  __typename?: 'Backlink';
  anchor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalNum: Scalars['Int']['output'];
  firstSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  form: Scalars['Boolean']['output'];
  frame: Scalars['Boolean']['output'];
  image: Scalars['Boolean']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalNum: Scalars['Int']['output'];
  lastSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lostlink: Scalars['Boolean']['output'];
  newlink: Scalars['Boolean']['output'];
  nofollow: Scalars['Boolean']['output'];
  pageAscore: Scalars['Int']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  sitewide: Scalars['Boolean']['output'];
  sourceSize?: Maybe<Scalars['Int']['output']>;
  sourceTitle?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  targetTitle?: Maybe<Scalars['String']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BacklinkOverview = {
  __typename?: 'BacklinkOverview';
  authorityScore: Scalars['Int']['output'];
  backlinkTotal: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  followed: Scalars['Int']['output'];
  form: Scalars['Int']['output'];
  frame: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['Int']['output'];
  ipClassic: Scalars['Int']['output'];
  ips: Scalars['Int']['output'];
  notFollowed: Scalars['Int']['output'];
  referringDomainTotal: Scalars['Int']['output'];
  referringDomains: Scalars['Int']['output'];
  sponsored: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userGeneratedContent: Scalars['Int']['output'];
};

export type BacklinkOverviewReport = {
  __typename?: 'BacklinkOverviewReport';
  backlinkOverview?: Maybe<BacklinkOverview>;
  errors?: Maybe<Array<ErrorDetail>>;
};

export type BacklinkProfileReport = {
  __typename?: 'BacklinkProfileReport';
  backlinkOverview?: Maybe<WpBlogBacklinkOverview>;
  backlinkOverviewChanges?: Maybe<WpBlogBacklinkOverviewChanges>;
};

export type BacklinkReport = {
  __typename?: 'BacklinkReport';
  backlinks?: Maybe<Array<Backlink>>;
  errors?: Maybe<Array<ErrorDetail>>;
};

export type Bundle = {
  __typename?: 'Bundle';
  bundleMarketingLineItems: Array<BundleMarketingLineItem>;
  confirmationUrl: Scalars['String']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creationOnly: Scalars['Boolean']['output'];
  customerType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  nonCheckoutOneTimeCoupon?: Maybe<Coupon>;
  nonCheckoutRecurringCoupon?: Maybe<Coupon>;
  prices: Array<Price>;
  slug: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  total: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  upsertsSubscription: Scalars['Boolean']['output'];
};

export type BundleMarketingLineItem = {
  __typename?: 'BundleMarketingLineItem';
  bundleId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BusinessOnboarding = {
  __typename?: 'BusinessOnboarding';
  account: Account;
  accountId: Scalars['Int']['output'];
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  addressZip?: Maybe<Scalars['String']['output']>;
  /** Whether address_city matches AI-generated value */
  aiGeneratedAddressCity: Scalars['Boolean']['output'];
  /** Whether address_state matches AI-generated value */
  aiGeneratedAddressState: Scalars['Boolean']['output'];
  /** Whether address_street matches AI-generated value */
  aiGeneratedAddressStreet: Scalars['Boolean']['output'];
  /** Whether address_zip matches AI-generated value */
  aiGeneratedAddressZip: Scalars['Boolean']['output'];
  /** Whether owner_name matches AI-generated value */
  aiGeneratedOwnerName: Scalars['Boolean']['output'];
  /** Whether phone matches AI-generated value */
  aiGeneratedPhone: Scalars['Boolean']['output'];
  /** Whether site_name matches AI-generated value */
  aiGeneratedSiteName: Scalars['Boolean']['output'];
  budgetBand?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmName?: Maybe<Scalars['String']['output']>;
  hasCrm?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  ownerName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  accountId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<TwilioNumber>;
  purpose?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Site>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use site. */
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated input type of CampaignChildrenEdit */
export type CampaignChildrenEditInput = {
  campaignId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId?: InputMaybe<Scalars['Int']['input']>;
  wpBlogId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CampaignChildrenEdit. */
export type CampaignChildrenEditPayload = {
  __typename?: 'CampaignChildrenEditPayload';
  campaign: Campaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CampaignEdit */
export type CampaignEditInput = {
  campaignId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CampaignEdit. */
export type CampaignEditPayload = {
  __typename?: 'CampaignEditPayload';
  campaign: Campaign;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CancelSubscriptionAtPeriodEnd */
export type CancelSubscriptionAtPeriodEndInput = {
  cancelAtPeriodEnd: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CancelSubscriptionAtPeriodEnd. */
export type CancelSubscriptionAtPeriodEndPayload = {
  __typename?: 'CancelSubscriptionAtPeriodEndPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancellationSurvey = {
  __typename?: 'CancellationSurvey';
  finalOutcome?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  offerAccepted?: Maybe<Scalars['String']['output']>;
  posthogSurveyId?: Maybe<Scalars['String']['output']>;
  productBeingCanceled?: Maybe<Scalars['String']['output']>;
  reasonCategory?: Maybe<Scalars['String']['output']>;
  refundEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type CarrotCrmConfig = {
  __typename?: 'CarrotCrmConfig';
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentUsers: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  maxUsers: Scalars['Int']['output'];
  planType: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

/** Autogenerated input type of CarrotCrmOptInUser */
export type CarrotCrmOptInUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CarrotCrmOptInUser. */
export type CarrotCrmOptInUserPayload = {
  __typename?: 'CarrotCrmOptInUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorDetail>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConnectLocation */
export type ConnectLocationInput = {
  /** The GBP account resource name (e.g., accounts/123) */
  accountId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable business name */
  locationDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** The v1 location resource name (e.g., locations/456) */
  locationName: Scalars['String']['input'];
  /** The marketing strategy ID */
  marketingStrategyId: Scalars['Int']['input'];
};

/** Autogenerated return type of ConnectLocation. */
export type ConnectLocationPayload = {
  __typename?: 'ConnectLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpConnection?: Maybe<GbpIntegration>;
};

export type ContentStrategy = {
  __typename?: 'ContentStrategy';
  aiResult: Scalars['JSON']['output'];
  assetsPlan?: Maybe<Scalars['JSON']['output']>;
  captionsAndAltText?: Maybe<Scalars['JSON']['output']>;
  contentStrategySummary?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  homepageOverview?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  internalLinkingPlan?: Maybe<Scalars['JSON']['output']>;
  marketingStrategyId: Scalars['Int']['output'];
  pages?: Maybe<Scalars['JSON']['output']>;
  schemaPlan?: Maybe<Scalars['JSON']['output']>;
  siteId?: Maybe<Scalars['String']['output']>;
  toneAndStoryUsage?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  active?: Maybe<Scalars['Boolean']['output']>;
  amountOff?: Maybe<Scalars['Int']['output']>;
  bundleable?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentOff?: Maybe<Scalars['Int']['output']>;
  processorId?: Maybe<Scalars['String']['output']>;
  redeemBy?: Maybe<Scalars['ISO8601DateTime']['output']>;
  timesRedeemed?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CreateAndChargeBundleInvoice */
export type CreateAndChargeBundleInvoiceInput = {
  bundleId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateAndChargeBundleInvoice. */
export type CreateAndChargeBundleInvoicePayload = {
  __typename?: 'CreateAndChargeBundleInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Error>;
  invoice?: Maybe<StripeInvoice>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAndChargeInvoice */
export type CreateAndChargeInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponIds: Array<Scalars['Int']['input']>;
  prices: Array<PriceQuantity>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateAndChargeInvoice. */
export type CreateAndChargeInvoicePayload = {
  __typename?: 'CreateAndChargeInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<StripeInvoice>;
};

/** Autogenerated input type of CreateAndChargeVideoPostInvoice */
export type CreateAndChargeVideoPostInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponIds: Array<Scalars['Int']['input']>;
  seconds: Scalars['Int']['input'];
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateAndChargeVideoPostInvoice. */
export type CreateAndChargeVideoPostInvoicePayload = {
  __typename?: 'CreateAndChargeVideoPostInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<StripeInvoice>;
};

/** Autogenerated input type of CreateBundle */
export type CreateBundleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmationUrl?: InputMaybe<Scalars['String']['input']>;
  couponId?: InputMaybe<Scalars['Int']['input']>;
  creationOnly?: InputMaybe<Scalars['Boolean']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  marketingLineItems: Array<Scalars['String']['input']>;
  nonCheckoutOneTimeCouponId?: InputMaybe<Scalars['Int']['input']>;
  nonCheckoutRecurringCouponId?: InputMaybe<Scalars['Int']['input']>;
  priceIds: Array<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  total: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBundle. */
export type CreateBundlePayload = {
  __typename?: 'CreateBundlePayload';
  bundle?: Maybe<Bundle>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateUpcomingInvoice */
export type CreateUpcomingInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  items: Array<PriceQuantity>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateUpcomingInvoice. */
export type CreateUpcomingInvoicePayload = {
  __typename?: 'CreateUpcomingInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<PaySubscriptionDiscount>;
  errors: Array<UserInputError>;
  removedDiscount?: Maybe<PaySubscriptionDiscount>;
  upcomingInvoice?: Maybe<UpcomingInvoicePreview>;
};

/** Autogenerated input type of DeleteBundle */
export type DeleteBundleInput = {
  bundleId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteBundle. */
export type DeleteBundlePayload = {
  __typename?: 'DeleteBundlePayload';
  bundle?: Maybe<Bundle>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteFeature */
export type DeleteFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteFeature. */
export type DeleteFeaturePayload = {
  __typename?: 'DeleteFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteMarketingStrategy */
export type DeleteMarketingStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteMarketingStrategy. */
export type DeleteMarketingStrategyPayload = {
  __typename?: 'DeleteMarketingStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteProductFeature */
export type DeleteProductFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  productFeatureId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteProductFeature. */
export type DeleteProductFeaturePayload = {
  __typename?: 'DeleteProductFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteReviewReply */
export type DeleteReviewReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GBP review ID */
  reviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReviewReply. */
export type DeleteReviewReplyPayload = {
  __typename?: 'DeleteReviewReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpReview?: Maybe<GbpReview>;
};

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of DeleteUser. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of Disconnect */
export type DisconnectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The marketing strategy ID */
  marketingStrategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of Disconnect. */
export type DisconnectPayload = {
  __typename?: 'DisconnectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Error = {
  __typename?: 'Error';
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ErrorDetail = {
  __typename?: 'ErrorDetail';
  code?: Maybe<Scalars['String']['output']>;
  httpCode?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Feature = {
  __typename?: 'Feature';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  productFeatures: Array<ProductFeature>;
  products: Array<Product>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FeaturePermission = {
  __typename?: 'FeaturePermission';
  feature: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

/** Status of a Google Business Profile connection */
export enum GbpConnectionStatus {
  /** User action needed (e.g., re-authentication) */
  ActionRequired = 'action_required',
  /** Active and healthy connection */
  Connected = 'connected',
  /** Error state, retry available */
  Error = 'error',
  /** No OAuth connection established */
  NotConnected = 'not_connected',
  /** Removed by the customer; deletion in progress */
  Removing = 'removing',
  /** Sync in progress */
  Syncing = 'syncing'
}

export type GbpConsentUrl = {
  __typename?: 'GbpConsentUrl';
  consentUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorDetail>;
};

/** A Google Business Profile connection for a marketing strategy */
export type GbpIntegration = {
  __typename?: 'GbpIntegration';
  /** Whether the connection is active and can be used */
  active: Scalars['Boolean']['output'];
  /** Whether call tracking is enabled for this connection */
  callTrackingEnabled: Scalars['Boolean']['output'];
  /** Original primary phone stored when call tracking was enabled */
  callTrackingPreviousPhone?: Maybe<Scalars['String']['output']>;
  /** Whether the connection is fully connected */
  connected: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Error message if status is error or action_required */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The GBP account resource name (e.g., accounts/123) */
  googleAccountId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Last successful review sync timestamp */
  lastReviewSyncAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last successful sync timestamp */
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Human-readable business name */
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  /** The v1 location resource name (e.g., locations/456) */
  locationName?: Maybe<Scalars['String']['output']>;
  marketingStrategyId: Scalars['Int']['output'];
  /** Whether the connection requires user action */
  needsAttention: Scalars['Boolean']['output'];
  /** Business profile data synced from Google */
  profile?: Maybe<GbpProfile>;
  /** Customer reviews */
  reviews: GbpReviewConnection;
  /** Total number of reviews */
  reviewsCount: Scalars['Int']['output'];
  /** Connection status */
  status: GbpConnectionStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A Google Business Profile connection for a marketing strategy */
export type GbpIntegrationReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

/** A Google Business Profile location */
export type GbpLocation = {
  __typename?: 'GbpLocation';
  /** The GBP account ID (e.g., accounts/123456789) */
  accountId: Scalars['String']['output'];
  /** Formatted address string */
  address?: Maybe<Scalars['String']['output']>;
  /** Whether the location has voice of merchant verification */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  /** The v1 location resource name (e.g., locations/456) */
  locationName: Scalars['String']['output'];
  /** Business name/title of the location */
  title: Scalars['String']['output'];
};

/** Google Business Profile business information */
export type GbpProfile = {
  __typename?: 'GbpProfile';
  /** Additional phone numbers */
  additionalPhones: Array<Scalars['String']['output']>;
  /** Street address lines */
  addressLines: Array<Scalars['String']['output']>;
  /** All phone numbers (primary + additional) */
  allPhones: Array<Scalars['String']['output']>;
  /** Business name */
  businessName?: Maybe<Scalars['String']['output']>;
  /** Business categories (primary and additional) */
  categories: Scalars['JSON']['output'];
  /** Country code */
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Formatted full address */
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** Additional GBP attributes */
  gbpAttributes: Scalars['JSON']['output'];
  id: Scalars['Int']['output'];
  /** City/locality */
  locality?: Maybe<Scalars['String']['output']>;
  /** Postal/ZIP code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Primary phone number */
  primaryPhone?: Maybe<Scalars['String']['output']>;
  /** State/region */
  region?: Maybe<Scalars['String']['output']>;
  /** Regular business hours */
  regularHours: Scalars['JSON']['output'];
  /** Special hours (holidays, etc.) */
  specialHours: Scalars['JSON']['output'];
  /** Whether profile has been synced */
  synced: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Business website URL */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Input fields for updating a Google Business Profile */
export type GbpProfileInput = {
  /** Additional phone numbers */
  additionalPhones?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Street address lines */
  addressLines?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Business name */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Country code (e.g., US) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** City/locality */
  locality?: InputMaybe<Scalars['String']['input']>;
  /** Postal/ZIP code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Primary phone number */
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  /** State/region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Regular business hours */
  regularHours?: InputMaybe<GbpRegularHoursInput>;
  /** Website URL */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Regular business hours */
export type GbpRegularHoursInput = {
  /** List of time periods */
  periods: Array<GbpTimePeriodInput>;
};

/** A Google Business Profile customer review */
export type GbpReview = {
  __typename?: 'GbpReview';
  /** Review comment text */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the review was posted */
  createTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the review has a reply */
  hasReply: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Google's unique review identifier */
  reviewId: Scalars['String']['output'];
  /** Business reply to the review */
  reviewReplyText?: Maybe<Scalars['String']['output']>;
  /** When the reply was last updated */
  reviewReplyUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reviewer's display name */
  reviewerName?: Maybe<Scalars['String']['output']>;
  /** Reviewer's profile photo URL */
  reviewerPhotoUrl?: Maybe<Scalars['String']['output']>;
  /** Star rating (1-5) */
  starRating?: Maybe<Scalars['Int']['output']>;
  /** When the review was last modified */
  updateTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for GbpReview. */
export type GbpReviewConnection = {
  __typename?: 'GbpReviewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GbpReviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GbpReview>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GbpReviewEdge = {
  __typename?: 'GbpReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GbpReview>;
};

/** Time of day with hours and minutes */
export type GbpTimeOfDayInput = {
  /** Hour (0-23) */
  hours: Scalars['Int']['input'];
  /** Minutes (0-59) */
  minutes?: InputMaybe<Scalars['Int']['input']>;
};

/** A time period for business hours */
export type GbpTimePeriodInput = {
  /** Day the period closes (MONDAY, TUESDAY, etc.) */
  closeDay: Scalars['String']['input'];
  /** Closing time */
  closeTime: GbpTimeOfDayInput;
  /** Day the period opens (MONDAY, TUESDAY, etc.) */
  openDay: Scalars['String']['input'];
  /** Opening time */
  openTime: GbpTimeOfDayInput;
};

export type GoogleAuthConfig = {
  __typename?: 'GoogleAuthConfig';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type GoogleSiteVerification = {
  __typename?: 'GoogleSiteVerification';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verificationMethod?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of HideSiteAuditReportIssueDetail */
export type HideSiteAuditReportIssueDetailInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  issueId: Scalars['Int']['input'];
};

/** Autogenerated return type of HideSiteAuditReportIssueDetail. */
export type HideSiteAuditReportIssueDetailPayload = {
  __typename?: 'HideSiteAuditReportIssueDetailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of HideSiteAuditReportIssue */
export type HideSiteAuditReportIssueInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['Int']['input'];
};

/** Autogenerated return type of HideSiteAuditReportIssue. */
export type HideSiteAuditReportIssuePayload = {
  __typename?: 'HideSiteAuditReportIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of InitiateAudit */
export type InitiateAuditInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The site's ID on its platform. Only WordPress sites are reachable. */
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use platformSiteId. */
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of InitiateAudit. */
export type InitiateAuditPayload = {
  __typename?: 'InitiateAuditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type KeywordOverviews = {
  __typename?: 'KeywordOverviews';
  difficulty?: Maybe<Scalars['Int']['output']>;
  phrase: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  traffic?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  volume: Scalars['Int']['output'];
};

export type KeywordReport = {
  __typename?: 'KeywordReport';
  hasMoreResults?: Maybe<Scalars['Boolean']['output']>;
  keywordOverviews?: Maybe<Array<KeywordOverviews>>;
  orderBy?: Maybe<Scalars['String']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  phraseSearchType?: Maybe<Scalars['String']['output']>;
  reportType: Report;
  searchTerm: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['String']['output']>;
};

export type LandingPageReport = {
  __typename?: 'LandingPageReport';
  avgEngagementTimePerSession?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Int']['output'];
  landingPage: Scalars['String']['output'];
  pageViewsPerVisitor?: Maybe<Scalars['Float']['output']>;
  visitors: Scalars['Int']['output'];
};

export type LogoCandidate = {
  __typename?: 'LogoCandidate';
  confidence: Scalars['Float']['output'];
  height: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type MarketingLocation = {
  __typename?: 'MarketingLocation';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  marketingStrategyId: Scalars['Int']['output'];
  primary: Scalars['Boolean']['output'];
  region?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MarketingStrategy = {
  __typename?: 'MarketingStrategy';
  accountId: Scalars['Int']['output'];
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry: Scalars['String']['output'];
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  addressZip?: Maybe<Scalars['String']['output']>;
  /** Whether address_city matches AI-generated value */
  aiGeneratedAddressCity: Scalars['Boolean']['output'];
  /** Whether address_state matches AI-generated value */
  aiGeneratedAddressState: Scalars['Boolean']['output'];
  /** Whether address_street matches AI-generated value */
  aiGeneratedAddressStreet: Scalars['Boolean']['output'];
  /** Whether address_zip matches AI-generated value */
  aiGeneratedAddressZip: Scalars['Boolean']['output'];
  /** Whether credentials matches AI-generated value */
  aiGeneratedCredentials: Scalars['Boolean']['output'];
  /** Whether ideal_client matches AI-generated value */
  aiGeneratedIdealClient: Scalars['Boolean']['output'];
  /** Whether mission matches AI-generated value */
  aiGeneratedMission: Scalars['Boolean']['output'];
  /** Whether nationwide matches AI-generated value */
  aiGeneratedNationwide: Scalars['Boolean']['output'];
  /** Whether owner_name matches AI-generated value */
  aiGeneratedOwnerName: Scalars['Boolean']['output'];
  /** Whether phone matches AI-generated value */
  aiGeneratedPhone: Scalars['Boolean']['output'];
  /** Whether problem_solved matches AI-generated value */
  aiGeneratedProblemSolved: Scalars['Boolean']['output'];
  /** Whether service_areas matches AI-generated value */
  aiGeneratedServiceAreas: Scalars['Boolean']['output'];
  /** Whether site_name matches AI-generated value */
  aiGeneratedSiteName: Scalars['Boolean']['output'];
  /** Whether start_reason matches AI-generated value */
  aiGeneratedStartReason: Scalars['Boolean']['output'];
  /** Whether success_metrics matches AI-generated value */
  aiGeneratedSuccessMetrics: Scalars['Boolean']['output'];
  /** Whether success_stories matches AI-generated value */
  aiGeneratedSuccessStories: Scalars['Boolean']['output'];
  /** Whether tone matches AI-generated value */
  aiGeneratedTone: Scalars['Boolean']['output'];
  /** Whether unique_promise matches AI-generated value */
  aiGeneratedUniquePromise: Scalars['Boolean']['output'];
  aiLocationStrategy: Scalars['JSON']['output'];
  aiMarketingStrategy: Scalars['JSON']['output'];
  aiTargetLeadType?: Maybe<Scalars['JSON']['output']>;
  backgroundWorkerId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessText?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  contentStrategy?: Maybe<ContentStrategy>;
  crawlActorId?: Maybe<Scalars['String']['output']>;
  crawlDatasetId?: Maybe<Scalars['String']['output']>;
  /** Error message if site crawl failed */
  crawlError?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  credentials: Array<Scalars['String']['output']>;
  customerSummary?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['JSON']['output']>;
  externalSite?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Scalars['JSON']['output']>;
  /** Google Business Profile connection */
  gbpConnection?: Maybe<GbpIntegration>;
  /** Error message if generation failed */
  generationError?: Maybe<Scalars['String']['output']>;
  /** The step that failed during generation */
  generationFailedStep?: Maybe<Scalars['String']['output']>;
  /** Status of AI generation workflow (pending, in_progress, completed, failed) */
  generationStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  idealClient?: Maybe<Scalars['String']['output']>;
  marketingLocations: Array<MarketingLocation>;
  mission?: Maybe<Scalars['String']['output']>;
  /** User-facing strategy name */
  name?: Maybe<Scalars['String']['output']>;
  nationwide?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  patternSource?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Error message if site preview generation failed */
  previewError?: Maybe<Scalars['String']['output']>;
  /** Session ID for pre-generated site preview */
  previewSessionId?: Maybe<Scalars['String']['output']>;
  problemSolved?: Maybe<Scalars['String']['output']>;
  questionsToIncreaseConfidence?: Maybe<Scalars['JSON']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  secondaryCandidates?: Maybe<Scalars['JSON']['output']>;
  seoStrategy?: Maybe<SeoStrategy>;
  serviceAreas: Array<Scalars['String']['output']>;
  /** Logo and color palette design choices */
  siteDesign?: Maybe<SiteDesign>;
  siteName?: Maybe<Scalars['String']['output']>;
  siteTypeSlug?: Maybe<Scalars['String']['output']>;
  siteTypeTitle?: Maybe<Scalars['String']['output']>;
  /** Active sites associated with this strategy */
  sites: Array<Site>;
  startReason?: Maybe<Scalars['String']['output']>;
  status: MarketingStrategyStatus;
  successMetrics: Array<Scalars['String']['output']>;
  successStories: Array<Scalars['String']['output']>;
  tone: Array<Scalars['String']['output']>;
  uniquePromise?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Active sites associated with this strategy
   * @deprecated Use sites.
   */
  wpBlogs: Array<WpBlog>;
};

export enum MarketingStrategyStatus {
  Completed = 'completed',
  Confirmed = 'confirmed',
  Processing = 'processing',
  Ready = 'ready'
}

export type MembershipBuilderSelection = {
  __typename?: 'MembershipBuilderSelection';
  price: Price;
  quantity: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type MembershipEditor = {
  __typename?: 'MembershipEditor';
  annualPrice: Price;
  availabilityErrors: Array<Scalars['String']['output']>;
  available: Scalars['Boolean']['output'];
  interval: Scalars['String']['output'];
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  minimumErrors: Array<Scalars['String']['output']>;
  monthlyPrice: Price;
  product: Product;
  quantity: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type MembershipManagement = {
  __typename?: 'MembershipManagement';
  balance?: Maybe<Scalars['Int']['output']>;
  cancellationRequestLink?: Maybe<Scalars['String']['output']>;
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  payPaymentMethod?: Maybe<PayPaymentMethod>;
  paySubscription?: Maybe<PaySubscription>;
};

export type Mutation = {
  __typename?: 'Mutation';
  actionItemDismiss?: Maybe<ActionItemDismissPayload>;
  activeAccountUpdate?: Maybe<ActiveAccountUpdatePayload>;
  addPriceToSubscription?: Maybe<AddPriceToSubscriptionPayload>;
  agencyAddClient?: Maybe<AddClientPayload>;
  buyPhoneNumber?: Maybe<PhoneNumberBuyPayload>;
  campaignChildrenEdit?: Maybe<CampaignChildrenEditPayload>;
  campaignEdit?: Maybe<CampaignEditPayload>;
  cancelSubscriptionAtPeriodEnd?: Maybe<CancelSubscriptionAtPeriodEndPayload>;
  carrotCrmOptInUser?: Maybe<CarrotCrmOptInUserPayload>;
  createAccount?: Maybe<AccountCreationPayload>;
  createAndChargeBundleInvoice?: Maybe<CreateAndChargeBundleInvoicePayload>;
  createAndChargeInvoice?: Maybe<CreateAndChargeInvoicePayload>;
  createAndChargeVideoPostInvoice?: Maybe<CreateAndChargeVideoPostInvoicePayload>;
  createBundle?: Maybe<CreateBundlePayload>;
  createUpcomingInvoice?: Maybe<CreateUpcomingInvoicePayload>;
  deleteBundle?: Maybe<DeleteBundlePayload>;
  /** Delete a new Feature. */
  deleteFeature?: Maybe<DeleteFeaturePayload>;
  deleteMarketingStrategy?: Maybe<DeleteMarketingStrategyPayload>;
  /** Unlink a Feature from a Product. */
  deleteProductFeature?: Maybe<DeleteProductFeaturePayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Connect a Google Business Profile location to a marketing strategy */
  gbpConnectLocation?: Maybe<ConnectLocationPayload>;
  /** Delete a reply from a Google Business Profile review */
  gbpDeleteReviewReply?: Maybe<DeleteReviewReplyPayload>;
  /** Disconnect a Google Business Profile from a marketing strategy */
  gbpDisconnect?: Maybe<DisconnectPayload>;
  /** Disable call tracking on a Google Business Profile location */
  gbpRemoveCallTracking?: Maybe<RemoveCallTrackingPayload>;
  /** Create or update a reply to a Google Business Profile review */
  gbpReplyToReview?: Maybe<ReplyToReviewPayload>;
  /** Enable call tracking on a Google Business Profile location */
  gbpSetCallTracking?: Maybe<SetCallTrackingPayload>;
  /** Manually sync profile and reviews for a Google Business Profile connection */
  gbpSyncNow?: Maybe<SyncNowPayload>;
  /** Update a Google Business Profile on Google */
  gbpUpdateProfile?: Maybe<UpdateProfilePayload>;
  hideSiteAuditReportIssue?: Maybe<HideSiteAuditReportIssuePayload>;
  hideSiteAuditReportIssueDetail?: Maybe<HideSiteAuditReportIssueDetailPayload>;
  initiateAudit?: Maybe<InitiateAuditPayload>;
  onboardingUpdate?: Maybe<OnboardingUpdatePayload>;
  pauseSubscription?: Maybe<PauseSubscriptionPayload>;
  phoneNumberDestroy?: Maybe<PhoneNumberDestroyPayload>;
  /** Edit an existing phone number for call tracking. */
  phoneNumberEdit?: Maybe<PhoneNumberEditPayload>;
  retriggerSitePreview?: Maybe<RetriggerSitePreviewPayload>;
  siteDeactivate?: Maybe<SiteDeactivatePayload>;
  /** Regenerate AI color palettes for site design */
  siteDesignRegeneratePalettes?: Maybe<RegeneratePalettesPayload>;
  /** Save branding choices (logo and palette) during onboarding */
  siteDesignSaveBranding?: Maybe<SaveBrandingPayload>;
  /** Select a color palette from AI-generated options */
  siteDesignSelectPalette?: Maybe<SelectPalettePayload>;
  siteEdit?: Maybe<SiteEditPayload>;
  siteUpdateMappedDomain?: Maybe<SiteUpdateMappedDomainPayload>;
  stripeBundleCheckout?: Maybe<StripeBundleCheckoutPayload>;
  stripeCustomerPortal?: Maybe<StripeCustomerPortalPayload>;
  stripeSubscriptionCheckout?: Maybe<StripeSubscriptionCheckoutPayload>;
  submitCancellationSurvey?: Maybe<SubmitCancellationSurveyPayload>;
  syncWordpressMetadata?: Maybe<SyncWordpressMetadataPayload>;
  teamMemberAcceptInvite?: Maybe<TeamMemberAcceptInvitePayload>;
  teamMemberAddToAccount?: Maybe<TeamMemberAddToAccountPayload>;
  teamMemberBlogRoleUpdate?: Maybe<TeamMemberBlogRoleUpdatePayload>;
  teamMemberDelete?: Maybe<TeamMemberDeletePayload>;
  teamMemberEdit?: Maybe<TeamMemberEditPayload>;
  /** Set or unset a number as spam for an account. */
  toggleBlockedNumber?: Maybe<ToggleBlockedNumberPayload>;
  trackSignup?: Maybe<TrackSignupPayload>;
  /** Create a new Twilio subaccount for the given account. */
  twilioSubaccountCreate?: Maybe<TwilioSubaccountCreatePayload>;
  unhideAllSiteAuditReportIssueDetails?: Maybe<UnhideAllSiteAuditReportIssueDetailsPayload>;
  unhideAllSiteAuditReportIssues?: Maybe<UnhideAllSiteAuditReportIssuesPayload>;
  /** Update an existing Feature. */
  updateFeature?: Maybe<UpdateFeaturePayload>;
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  upgradeContentProToStandard?: Maybe<UpgradeContentProToStandardPayload>;
  /** Create a new ActionItemTemplate or update an existing one by action_type. */
  upsertActionItemTemplate?: Maybe<ActionItemTemplateUpsertPayload>;
  upsertBusinessOnboarding?: Maybe<UpsertBusinessOnboardingPayload>;
  /** Create a new Feature or update an existing one, and link it to Products. */
  upsertFeature?: Maybe<UpsertFeaturePayload>;
  upsertMarketingStrategy?: Maybe<UpsertMarketingStrategyPayload>;
  /** @deprecated No replacement; scheduled for removal. */
  wpBlogCreate?: Maybe<WpBlogCreatePayload>;
  /** @deprecated Use siteDeactivate. */
  wpBlogDeactivate?: Maybe<WpBlogDeactivatePayload>;
  /** @deprecated Use siteEdit. */
  wpBlogEdit?: Maybe<WpBlogEditPayload>;
  /** @deprecated No replacement; scheduled for removal. */
  wpBlogUpdate?: Maybe<WpBlogUpdatePayload>;
  /** @deprecated Use siteUpdateMappedDomain. */
  wpBlogUpdateMappedDomain?: Maybe<WpBlogUpdateMappedDomainPayload>;
};


export type MutationActionItemDismissArgs = {
  input: ActionItemDismissInput;
};


export type MutationActiveAccountUpdateArgs = {
  input: ActiveAccountUpdateInput;
};


export type MutationAddPriceToSubscriptionArgs = {
  input: AddPriceToSubscriptionInput;
};


export type MutationAgencyAddClientArgs = {
  input: AddClientInput;
};


export type MutationBuyPhoneNumberArgs = {
  input: PhoneNumberBuyInput;
};


export type MutationCampaignChildrenEditArgs = {
  input: CampaignChildrenEditInput;
};


export type MutationCampaignEditArgs = {
  input: CampaignEditInput;
};


export type MutationCancelSubscriptionAtPeriodEndArgs = {
  input: CancelSubscriptionAtPeriodEndInput;
};


export type MutationCarrotCrmOptInUserArgs = {
  input: CarrotCrmOptInUserInput;
};


export type MutationCreateAccountArgs = {
  input: AccountCreationInput;
};


export type MutationCreateAndChargeBundleInvoiceArgs = {
  input: CreateAndChargeBundleInvoiceInput;
};


export type MutationCreateAndChargeInvoiceArgs = {
  input: CreateAndChargeInvoiceInput;
};


export type MutationCreateAndChargeVideoPostInvoiceArgs = {
  input: CreateAndChargeVideoPostInvoiceInput;
};


export type MutationCreateBundleArgs = {
  input: CreateBundleInput;
};


export type MutationCreateUpcomingInvoiceArgs = {
  input: CreateUpcomingInvoiceInput;
};


export type MutationDeleteBundleArgs = {
  input: DeleteBundleInput;
};


export type MutationDeleteFeatureArgs = {
  input: DeleteFeatureInput;
};


export type MutationDeleteMarketingStrategyArgs = {
  input: DeleteMarketingStrategyInput;
};


export type MutationDeleteProductFeatureArgs = {
  input: DeleteProductFeatureInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationGbpConnectLocationArgs = {
  input: ConnectLocationInput;
};


export type MutationGbpDeleteReviewReplyArgs = {
  input: DeleteReviewReplyInput;
};


export type MutationGbpDisconnectArgs = {
  input: DisconnectInput;
};


export type MutationGbpRemoveCallTrackingArgs = {
  input: RemoveCallTrackingInput;
};


export type MutationGbpReplyToReviewArgs = {
  input: ReplyToReviewInput;
};


export type MutationGbpSetCallTrackingArgs = {
  input: SetCallTrackingInput;
};


export type MutationGbpSyncNowArgs = {
  input: SyncNowInput;
};


export type MutationGbpUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationHideSiteAuditReportIssueArgs = {
  input: HideSiteAuditReportIssueInput;
};


export type MutationHideSiteAuditReportIssueDetailArgs = {
  input: HideSiteAuditReportIssueDetailInput;
};


export type MutationInitiateAuditArgs = {
  input: InitiateAuditInput;
};


export type MutationOnboardingUpdateArgs = {
  input: OnboardingUpdateInput;
};


export type MutationPauseSubscriptionArgs = {
  input: PauseSubscriptionInput;
};


export type MutationPhoneNumberDestroyArgs = {
  input: PhoneNumberDestroyInput;
};


export type MutationPhoneNumberEditArgs = {
  input: PhoneNumberEditInput;
};


export type MutationRetriggerSitePreviewArgs = {
  input: RetriggerSitePreviewInput;
};


export type MutationSiteDeactivateArgs = {
  input: SiteDeactivateInput;
};


export type MutationSiteDesignRegeneratePalettesArgs = {
  input: RegeneratePalettesInput;
};


export type MutationSiteDesignSaveBrandingArgs = {
  input: SaveBrandingInput;
};


export type MutationSiteDesignSelectPaletteArgs = {
  input: SelectPaletteInput;
};


export type MutationSiteEditArgs = {
  input: SiteEditInput;
};


export type MutationSiteUpdateMappedDomainArgs = {
  input: SiteUpdateMappedDomainInput;
};


export type MutationStripeBundleCheckoutArgs = {
  input: StripeBundleCheckoutInput;
};


export type MutationStripeCustomerPortalArgs = {
  input: StripeCustomerPortalInput;
};


export type MutationStripeSubscriptionCheckoutArgs = {
  input: StripeSubscriptionCheckoutInput;
};


export type MutationSubmitCancellationSurveyArgs = {
  input: SubmitCancellationSurveyInput;
};


export type MutationSyncWordpressMetadataArgs = {
  input: SyncWordpressMetadataInput;
};


export type MutationTeamMemberAcceptInviteArgs = {
  input: TeamMemberAcceptInviteInput;
};


export type MutationTeamMemberAddToAccountArgs = {
  input: TeamMemberAddToAccountInput;
};


export type MutationTeamMemberBlogRoleUpdateArgs = {
  input: TeamMemberBlogRoleUpdateInput;
};


export type MutationTeamMemberDeleteArgs = {
  input: TeamMemberDeleteInput;
};


export type MutationTeamMemberEditArgs = {
  input: TeamMemberEditInput;
};


export type MutationToggleBlockedNumberArgs = {
  input: ToggleBlockedNumberInput;
};


export type MutationTrackSignupArgs = {
  input: TrackSignupInput;
};


export type MutationTwilioSubaccountCreateArgs = {
  input: TwilioSubaccountCreateInput;
};


export type MutationUnhideAllSiteAuditReportIssueDetailsArgs = {
  input: UnhideAllSiteAuditReportIssueDetailsInput;
};


export type MutationUnhideAllSiteAuditReportIssuesArgs = {
  input: UnhideAllSiteAuditReportIssuesInput;
};


export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpgradeContentProToStandardArgs = {
  input: UpgradeContentProToStandardInput;
};


export type MutationUpsertActionItemTemplateArgs = {
  input: ActionItemTemplateUpsertInput;
};


export type MutationUpsertBusinessOnboardingArgs = {
  input: UpsertBusinessOnboardingInput;
};


export type MutationUpsertFeatureArgs = {
  input: UpsertFeatureInput;
};


export type MutationUpsertMarketingStrategyArgs = {
  input: UpsertMarketingStrategyInput;
};


export type MutationWpBlogCreateArgs = {
  input: WpBlogCreateInput;
};


export type MutationWpBlogDeactivateArgs = {
  input: WpBlogDeactivateInput;
};


export type MutationWpBlogEditArgs = {
  input: WpBlogEditInput;
};


export type MutationWpBlogUpdateArgs = {
  input: WpBlogUpdateInput;
};


export type MutationWpBlogUpdateMappedDomainArgs = {
  input: WpBlogUpdateMappedDomainInput;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  collaboration?: Maybe<Scalars['String']['output']>;
  collaborations: Array<Scalars['String']['output']>;
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyCity?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  companyState?: Maybe<Scalars['String']['output']>;
  companyZip?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  experience?: Maybe<Scalars['String']['output']>;
  experiences: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  marketCity?: Maybe<Scalars['String']['output']>;
  marketState?: Maybe<Scalars['String']['output']>;
  marketZip?: Maybe<Scalars['String']['output']>;
  primaryIndustries: Array<Scalars['String']['output']>;
  primaryIndustry?: Maybe<Scalars['String']['output']>;
  primaryIndustryFocus?: Maybe<Scalars['String']['output']>;
  primaryIndustryFocuses: Scalars['JSON']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  referenceDetails?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export enum OnboardingStatus {
  /** The onboarding process has been completed. */
  Completed = 'COMPLETED',
  /** A site preview has been selected. */
  MsCompleted = 'MS_COMPLETED',
  /** The marketing strategy has been confirmed. */
  MsConfirmed = 'MS_CONFIRMED',
  /** A marketing strategy has been created. */
  MsCreated = 'MS_CREATED',
  /** The marketing strategy is being processed. */
  MsProcessing = 'MS_PROCESSING',
  /** The marketing strategy is ready. */
  MsReady = 'MS_READY',
  /** The account has been created but onboarding has not yet begun. */
  NotStarted = 'NOT_STARTED'
}

/** Autogenerated input type of OnboardingUpdate */
export type OnboardingUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  collaboration?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  companyState?: InputMaybe<Scalars['String']['input']>;
  companyZip?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  primaryIndustry?: InputMaybe<Scalars['String']['input']>;
  primaryIndustryFocus?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceDetails?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OnboardingUpdate. */
export type OnboardingUpdatePayload = {
  __typename?: 'OnboardingUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

export type OrganicOverviewReport = {
  __typename?: 'OrganicOverviewReport';
  domainOverviewHistories?: Maybe<Array<WpBlogDomainOverviewHistory>>;
  organicVisitors?: Maybe<Array<TrafficAndLeadsDataPoints>>;
};

export type OrganicProfileReport = {
  __typename?: 'OrganicProfileReport';
  keywords: Scalars['Int']['output'];
  keywordsChange?: Maybe<Scalars['Float']['output']>;
  organicVisitors: Scalars['Int']['output'];
  organicVisitorsChange?: Maybe<Scalars['Float']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Palette = {
  __typename?: 'Palette';
  alignment: Scalars['String']['output'];
  colors: PaletteColors;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
  suggestedDefaults: PaletteSuggestedDefaults;
  warnings: Array<Scalars['String']['output']>;
};

export type PaletteColors = {
  __typename?: 'PaletteColors';
  carrotColorAccent1: Scalars['String']['output'];
  carrotColorAccent2: Scalars['String']['output'];
  carrotColorAccent3: Scalars['String']['output'];
  carrotColorAccent4: Scalars['String']['output'];
  carrotColorBase1: Scalars['String']['output'];
  carrotColorBase2: Scalars['String']['output'];
  carrotColorContrast1: Scalars['String']['output'];
  carrotColorContrast2: Scalars['String']['output'];
};

export type PaletteSuggestedDefaults = {
  __typename?: 'PaletteSuggestedDefaults';
  background: Scalars['String']['output'];
  buttonBg: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Autogenerated input type of PauseSubscription */
export type PauseSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['Int']['input'];
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of PauseSubscription. */
export type PauseSubscriptionPayload = {
  __typename?: 'PauseSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  survey?: Maybe<CancellationSurvey>;
};

export type PayCharge = {
  __typename?: 'PayCharge';
  amount: Scalars['Int']['output'];
  amountRefunded?: Maybe<Scalars['Int']['output']>;
  applicationFeeAmount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<StripeInvoiceLineItem>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  processorId: Scalars['String']['output'];
  subscriptionId?: Maybe<Scalars['Int']['output']>;
  tax: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PayPaymentMethod = {
  __typename?: 'PayPaymentMethod';
  billingDetails?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerId: Scalars['Int']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  processorId: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PaySubscription = {
  __typename?: 'PaySubscription';
  addOns: Array<Price>;
  annualLegacyCouponAmount?: Maybe<Scalars['Int']['output']>;
  annualLegacyPrice?: Maybe<Scalars['Int']['output']>;
  applicationFeePercent?: Maybe<Scalars['Float']['output']>;
  cancelAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customerId: Scalars['Int']['output'];
  discount?: Maybe<PaySubscriptionDiscount>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  items: Array<PaySubscriptionItem>;
  latestInvoices: Array<StripeInvoice>;
  limits: Scalars['JSON']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  monthlyLegacyCouponAmount?: Maybe<Scalars['Int']['output']>;
  monthlyLegacyPrice?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pastDueCancelAtDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pastDueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  pendingCancellation: Scalars['Boolean']['output'];
  pendingUpdate: Scalars['Boolean']['output'];
  processorId: Scalars['String']['output'];
  processorPlan: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  requestedCancelAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  starter: Price;
  status: Scalars['String']['output'];
  trialEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usage: Scalars['JSON']['output'];
};

export type PaySubscriptionDiscount = {
  __typename?: 'PaySubscriptionDiscount';
  coupon: Coupon;
  endDate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  startDate: Scalars['Int']['output'];
};

export type PaySubscriptionItem = {
  __typename?: 'PaySubscriptionItem';
  paySubscriptionId: Scalars['Int']['output'];
  price: Price;
  priceId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  stripeId: Scalars['String']['output'];
};

/** Autogenerated input type of PhoneNumberBuy */
export type PhoneNumberBuyInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of PhoneNumberBuy. */
export type PhoneNumberBuyPayload = {
  __typename?: 'PhoneNumberBuyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  phoneNumber?: Maybe<TwilioNumber>;
};

/** Autogenerated input type of PhoneNumberDestroy */
export type PhoneNumberDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId: Scalars['Int']['input'];
};

/** Autogenerated return type of PhoneNumberDestroy. */
export type PhoneNumberDestroyPayload = {
  __typename?: 'PhoneNumberDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PhoneNumberEdit */
export type PhoneNumberEditInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forwardToNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberId: Scalars['Int']['input'];
};

/** Autogenerated return type of PhoneNumberEdit. */
export type PhoneNumberEditPayload = {
  __typename?: 'PhoneNumberEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  phoneNumber?: Maybe<TwilioNumber>;
};

export type Price = {
  __typename?: 'Price';
  active: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  annualSavings: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  listTitle?: Maybe<Scalars['String']['output']>;
  lookupKey?: Maybe<Scalars['String']['output']>;
  marketingList?: Maybe<Array<Scalars['String']['output']>>;
  monthlyPrice: Scalars['Int']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  product: Product;
  productId: Scalars['Int']['output'];
  stripeId?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  version?: Maybe<Scalars['Int']['output']>;
  wordpressLabel?: Maybe<Scalars['String']['output']>;
};

export type PriceQuantity = {
  priceId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type Product = {
  __typename?: 'Product';
  active?: Maybe<Scalars['Boolean']['output']>;
  canBundle: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Feature>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  membershipEditor?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  prices: Array<Price>;
  productFeatures: Array<ProductFeature>;
  starter?: Maybe<Scalars['Boolean']['output']>;
  stripeId?: Maybe<Scalars['String']['output']>;
  taxCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type ProductPricesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  customerType?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductFeature = {
  __typename?: 'ProductFeature';
  createdAt: Scalars['ISO8601DateTime']['output'];
  feature: Feature;
  id: Scalars['Int']['output'];
  product: Product;
  units?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ProductFeatureInput = {
  productId: Scalars['Int']['input'];
  units?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** A description of a User's Ability */
  ability?: Maybe<Array<Ability>>;
  /** An Account that the User can access */
  account: Account;
  /** A list of Accounts that the User can access */
  accounts: Array<Account>;
  /** An ActionItemTemplate */
  actionItemTemplate?: Maybe<ActionItemTemplate>;
  /** A list of ActionItemTemplates */
  actionItemTemplates: Array<ActionItemTemplate>;
  /** Agency billing usage: active sites, included sites, and overage */
  agencyBillingUsage: AgencyBillingUsage;
  /** A list of client accounts belonging to an agency */
  agencyClientAccounts: Array<Account>;
  availablePhoneNumbers?: Maybe<Array<TwilioApiPhoneNumber>>;
  /** Returns the backlink category report data */
  backlinkCategoryReport?: Maybe<WpBlogBacklinkOverview>;
  /** Returns the backlink profile report data */
  backlinkOverviewReport: Array<WpBlogBacklinkOverview>;
  /** Returns the backlink profile report data */
  backlinkProfileReport: BacklinkProfileReport;
  /** Returns the backlink report data */
  backlinkReport: Array<WpBlogBacklink>;
  /** A Bundle */
  bundle?: Maybe<Bundle>;
  /** A list of Bundles */
  bundles: Array<Bundle>;
  /** A Twilio Number */
  callTrackingNumber?: Maybe<TwilioNumber>;
  /** A list of Twilio Numbers */
  callTrackingNumbers?: Maybe<Array<TwilioNumber>>;
  /** A list of CarrotCrmConfigs that the User can access */
  carrotCrmConfigs: Array<CarrotCrmConfig>;
  /** Returns the competitor backlink profile report data */
  competitorBacklinkOverviewReport: BacklinkOverviewReport;
  /** Returns the competitor backlink report data */
  competitorBacklinkReport: BacklinkReport;
  /** A list of Coupons */
  coupons: Array<Coupon>;
  /** Backfills historical data if it is missing. */
  domainOverviewBackfill?: Maybe<Scalars['Boolean']['output']>;
  /** A Feature */
  feature?: Maybe<Feature>;
  /** A list of Features */
  features?: Maybe<Array<Feature>>;
  /** Returns all accessible Google Business Profile locations for a marketing strategy */
  gbpAccessibleLocations?: Maybe<Array<GbpLocation>>;
  /** Returns the Google Business Profile connection for a marketing strategy */
  gbpConnection?: Maybe<GbpIntegration>;
  /** Returns the Google OAuth consent URL for connecting a Google Business Profile */
  gbpConsentUrl?: Maybe<GbpConsentUrl>;
  /** Returns the HubSpot visitor identification token for the current user */
  hubspotToken: Scalars['String']['output'];
  /** Returns a Keyword Report */
  keywordReport?: Maybe<KeywordReport>;
  /** Returns the landing page report data */
  landingPageReport: Array<LandingPageReport>;
  /** Returns the latest Pay Charge */
  latestInvoice?: Maybe<PayCharge>;
  /** Returns a the options with which to build a Membership */
  membershipBuilderSelection?: Maybe<Array<MembershipBuilderSelection>>;
  /** Returns the options with which to edit a Membership */
  membershipEditor?: Maybe<Array<MembershipEditor>>;
  /** Returns a information to manage a membership */
  membershipManagement?: Maybe<MembershipManagement>;
  /** A Users Onboarding information */
  onboarding: Onboarding;
  /** Returns the organic profile report data */
  organicOverviewReport: OrganicOverviewReport;
  /** Returns the organic profile report data */
  organicProfileReport?: Maybe<OrganicProfileReport>;
  /** A Price */
  price?: Maybe<Price>;
  /** A list of Prices */
  prices: Array<Price>;
  /** A Product */
  product?: Maybe<Product>;
  /** A list of Products */
  products: Array<Product>;
  searchCodeSuggestions?: Maybe<SearchCodeSuggestions>;
  /** Returns Google Oauth consent URL for enabling Search Performance feature */
  searchPerformanceConsentUrl?: Maybe<SearchPerformanceConsentUrl>;
  /** Returns search performance data to populate the front end */
  searchPerformanceHistory?: Maybe<SearchPerformanceHistory>;
  /** Returns search performance data to populate the front end */
  searchPerformancePageUrl?: Maybe<SearchPerformancePageUrl>;
  /** Returns search performance data to populate the front end */
  searchPerformanceQueryString?: Maybe<SearchPerformanceQueryString>;
  /** A site */
  site?: Maybe<Site>;
  /** SiteAuditReportType */
  siteAuditReport?: Maybe<SiteAuditReport>;
  /** SiteAuditReportIssueDetailsType */
  siteAuditReportIssueDetails?: Maybe<AuditSnapshot>;
  /** Returns the site's backlink upsell report data */
  siteBacklinkUpsellReport?: Maybe<WpBlogBacklinkUpsell>;
  /** Returns the total visitors for multiple sites */
  siteDashboardVisitor: SiteDashboardVisitor;
  /** Site usage: included sites, current sites, upgrade requirement, and additional site cost */
  siteUsage: SiteUsage;
  /** Sites */
  sites: Array<Site>;
  /** Preview usage subscription usage */
  subscriptionInvoicePreview?: Maybe<StripeInvoice>;
  /** Returns an array of PaySubscriptions that include a Product. */
  subscriptionsByProduct: Array<PaySubscription>;
  teamMemberAbility?: Maybe<Array<Ability>>;
  /** Returns a list of valid roles for a Team Member Account */
  teamMemberAccountRoles?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns the top pages report data */
  topPagesReport: Array<TopPagesReport>;
  /** Returns the landing page report data */
  trafficAndLeadsReport: TrafficAndLeadsReport;
  /** Returns the landing page report data */
  trafficSourceReport: Array<TrafficSourceReport>;
  /** A User */
  user?: Maybe<User>;
  /** A list of Users */
  users: Array<User>;
  /** Returns a list of valid roles for a Team Member Blog Role */
  validTeamMemberBlogRoles: Array<Scalars['String']['output']>;
  /** Returns a list of Wordpress User Meta */
  wordpressUserMeta?: Maybe<WordpressUserMeta>;
  /**
   * A WpBlog
   * @deprecated Use site.
   */
  wpBlog?: Maybe<WpBlog>;
  /**
   * Returns the site's backlink upsell report data
   * @deprecated Use siteBacklinkUpsellReport.
   */
  wpBlogBacklinkUpsellReport?: Maybe<WpBlogBacklinkUpsell>;
  /**
   * A WpBlog
   * @deprecated Use sites.
   */
  wpBlogs: Array<WpBlog>;
};


export type QueryAbilityArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryActionItemTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryActionItemTemplatesArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  trigger?: InputMaybe<ActionItemTrigger>;
};


export type QueryAgencyBillingUsageArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAgencyClientAccountsArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryAvailablePhoneNumbersArgs = {
  accountId: Scalars['Int']['input'];
  areaCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  searchCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBacklinkCategoryReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBacklinkOverviewReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBacklinkProfileReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBacklinkReportArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBundleArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBundlesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCallTrackingNumberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCallTrackingNumbersArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryCompetitorBacklinkOverviewReportArgs = {
  domain: Scalars['String']['input'];
};


export type QueryCompetitorBacklinkReportArgs = {
  domain: Scalars['String']['input'];
  pageNumber: Scalars['Int']['input'];
};


export type QueryCouponsArgs = {
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDomainOverviewBackfillArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeatureArgs = {
  featureId: Scalars['Int']['input'];
};


export type QueryFeaturesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productStripeId?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGbpAccessibleLocationsArgs = {
  marketingStrategyId: Scalars['Int']['input'];
};


export type QueryGbpConnectionArgs = {
  marketingStrategyId: Scalars['Int']['input'];
};


export type QueryGbpConsentUrlArgs = {
  marketingStrategyId: Scalars['Int']['input'];
};


export type QueryKeywordReportArgs = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  phraseSearchType?: InputMaybe<Scalars['String']['input']>;
  reportType: Report;
  searchTerm: Scalars['String']['input'];
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLandingPageReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMembershipBuilderSelectionArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  selectedPrices?: InputMaybe<Array<PriceQuantity>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMembershipEditorArgs = {
  interval?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMembershipManagementArgs = {
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganicOverviewReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganicProfileReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPriceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lookupKey?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  processorId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPricesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bundleable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  lookupKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  nicknames?: InputMaybe<Array<Scalars['String']['input']>>;
  processorId?: InputMaybe<Scalars['String']['input']>;
  processorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  versions?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryProductArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  stripeId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCodeSuggestionsArgs = {
  code: Scalars['String']['input'];
  codeType: Scalars['String']['input'];
};


export type QuerySearchPerformanceConsentUrlArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchPerformanceHistoryArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  pageUrlFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  queryStringFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchPerformancePageUrlArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  pageUrlFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  queryStringFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchPerformanceQueryStringArgs = {
  days: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  pageUrlFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  queryStringFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteAuditReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteAuditReportIssueDetailsArgs = {
  auditSnapshotId: Scalars['Int']['input'];
  issueId: Scalars['Int']['input'];
};


export type QuerySiteBacklinkUpsellReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteDashboardVisitorArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySiteUsageArgs = {
  accountId: Scalars['Int']['input'];
};


export type QuerySitesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mappedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  platformSiteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QuerySubscriptionInvoicePreviewArgs = {
  accountId: Scalars['Int']['input'];
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySubscriptionsByProductArgs = {
  productName: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeamMemberAbilityArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopPagesReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTrafficAndLeadsReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTrafficSourceReportArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  wordpressUserId: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryWordpressUserMetaArgs = {
  meta: Array<Scalars['String']['input']>;
};


export type QueryWpBlogArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWpBlogBacklinkUpsellReportArgs = {
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWpBlogsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mappedDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  platformSiteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
  wordpressBlogIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Autogenerated input type of RegeneratePalettes */
export type RegeneratePalettesInput = {
  /** Index of the logo candidate to seed palettes from */
  candidateIndex?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The marketing strategy ID */
  marketingStrategyId: Scalars['Int']['input'];
};

/** Autogenerated return type of RegeneratePalettes. */
export type RegeneratePalettesPayload = {
  __typename?: 'RegeneratePalettesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  siteDesign?: Maybe<SiteDesign>;
};

/** Autogenerated input type of RemoveCallTracking */
export type RemoveCallTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GBP connection ID */
  gbpConnectionId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCallTracking. */
export type RemoveCallTrackingPayload = {
  __typename?: 'RemoveCallTrackingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpConnection?: Maybe<GbpIntegration>;
};

/** Autogenerated input type of ReplyToReview */
export type ReplyToReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The reply text to post */
  replyText: Scalars['String']['input'];
  /** The GBP review ID */
  reviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReplyToReview. */
export type ReplyToReviewPayload = {
  __typename?: 'ReplyToReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpReview?: Maybe<GbpReview>;
};

export enum Report {
  Domain = 'DOMAIN',
  Phrase = 'PHRASE'
}

export type RetentionOffer = {
  __typename?: 'RetentionOffer';
  /** Whether the hold switches an annual plan to monthly at renewal */
  annual?: Maybe<Scalars['Boolean']['output']>;
  couponProcessorId?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Int']['output']>;
  durationMonths?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  pauseDurationMonths?: Maybe<Scalars['Int']['output']>;
  /** When an annual plan renews as monthly with the hold */
  renewsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  targetProductSlug?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** Autogenerated input type of RetriggerSitePreview */
export type RetriggerSitePreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId: Scalars['Int']['input'];
};

/** Autogenerated return type of RetriggerSitePreview. */
export type RetriggerSitePreviewPayload = {
  __typename?: 'RetriggerSitePreviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  marketingStrategy?: Maybe<MarketingStrategy>;
};

/** Autogenerated input type of SaveBranding */
export type SaveBrandingInput = {
  /** Index of the logo candidate to select (optional) */
  candidateIndex?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The marketing strategy ID */
  marketingStrategyId: Scalars['Int']['input'];
  /** Index of the palette to select from ai_palettes */
  paletteIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of SaveBranding. */
export type SaveBrandingPayload = {
  __typename?: 'SaveBrandingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  siteDesign?: Maybe<SiteDesign>;
};

export type SearchCodeSuggestions = {
  __typename?: 'SearchCodeSuggestions';
  areaCodes?: Maybe<Array<Scalars['String']['output']>>;
  zipCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type SearchPerformanceConsentUrl = {
  __typename?: 'SearchPerformanceConsentUrl';
  consentUrl?: Maybe<Scalars['String']['output']>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformanceHistory = {
  __typename?: 'SearchPerformanceHistory';
  data?: Maybe<Array<SearchPerformanceHistoryInstance>>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformanceHistoryInstance = {
  __typename?: 'SearchPerformanceHistoryInstance';
  clicks: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  date: Scalars['ISO8601Date']['output'];
  impressions: Scalars['Float']['output'];
  position: Scalars['Float']['output'];
};

export type SearchPerformancePageUrl = {
  __typename?: 'SearchPerformancePageUrl';
  data?: Maybe<Array<SearchPerformancePageUrlInstance>>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformancePageUrlInstance = {
  __typename?: 'SearchPerformancePageUrlInstance';
  clicks: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  impressions: Scalars['Float']['output'];
  pageUrl: Scalars['String']['output'];
  position: Scalars['Float']['output'];
};

export type SearchPerformanceQueryString = {
  __typename?: 'SearchPerformanceQueryString';
  data?: Maybe<Array<SearchPerformanceQueryStringInstance>>;
  error?: Maybe<ErrorDetail>;
};

export type SearchPerformanceQueryStringInstance = {
  __typename?: 'SearchPerformanceQueryStringInstance';
  clicks: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  impressions: Scalars['Float']['output'];
  position: Scalars['Float']['output'];
  queryString: Scalars['String']['output'];
};

/** Autogenerated input type of SelectPalette */
export type SelectPaletteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The marketing strategy ID */
  marketingStrategyId: Scalars['Int']['input'];
  /** Index of the palette to select from ai_palettes */
  paletteIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of SelectPalette. */
export type SelectPalettePayload = {
  __typename?: 'SelectPalettePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  siteDesign?: Maybe<SiteDesign>;
};

export type SeoStrategy = {
  __typename?: 'SeoStrategy';
  aiKeywordResearch: Scalars['JSON']['output'];
  aiSeoStrategy: Scalars['JSON']['output'];
  aiTargetKeywords: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  marketingStrategyId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ServiceOrderGraph = {
  __typename?: 'ServiceOrderGraph';
  /** The ID of the account this order belongs to */
  accountId: Scalars['Int']['output'];
  /** When work was completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The UID of the ServiceOrder */
  id: Scalars['Int']['output'];
  /** The type of service order */
  serviceOrderType: ServiceOrderTypeGraph;
  /** The ID of the linked site, if any */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** When work began */
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Stripe invoice that triggered this order */
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * The ID of the linked site, if any
   * @deprecated Use siteId.
   */
  wpBlogId?: Maybe<Scalars['Int']['output']>;
};

export type ServiceOrderTypeGraph = {
  __typename?: 'ServiceOrderTypeGraph';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The UID of the ServiceOrderType */
  id: Scalars['Int']['output'];
  /** The display name of the service order type */
  name: Scalars['String']['output'];
  /** URL-safe identifier for the service order type */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SetCallTracking */
export type SetCallTrackingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GBP connection ID */
  gbpConnectionId: Scalars['ID']['input'];
  /** The call tracking phone number */
  trackingNumber: Scalars['String']['input'];
};

/** Autogenerated return type of SetCallTracking. */
export type SetCallTrackingPayload = {
  __typename?: 'SetCallTrackingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpConnection?: Maybe<GbpIntegration>;
};

export type Site = {
  __typename?: 'Site';
  /** The ID of the account that owns the site */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** The name of the account that owns the site */
  accountName?: Maybe<Scalars['String']['output']>;
  /** The ActionItems associated with the site */
  actionItems: Array<ActionItem>;
  /** A boolean indicating whether the site is archived */
  archived: Scalars['Boolean']['output'];
  /** The site's Semrush backlink overviews */
  backlinkOverviews: Array<WpBlogBacklinkOverview>;
  /** Whether the site uses a block theme */
  blockTheme?: Maybe<Scalars['Boolean']['output']>;
  /** The category of the site */
  category?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the site was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A boolean indicating whether the site is deleted */
  deleted: Scalars['Boolean']['output'];
  /** The site's Semrush domain overview history */
  domainOverviewHistories: Array<WpBlogDomainOverviewHistory>;
  /** The GoogleAuthConfig that the site is associated with */
  googleAuthConfig?: Maybe<GoogleAuthConfig>;
  /** The UID of the GoogleAuthConfig that the site is associated with */
  googleAuthConfigId?: Maybe<Scalars['Int']['output']>;
  /** The GoogleSiteVerification record for this site */
  googleSiteVerification?: Maybe<GoogleSiteVerification>;
  /** The UID of the site */
  id: Scalars['Int']['output'];
  /** The domain that a User has mapped to the site */
  mappedDomain?: Maybe<Scalars['String']['output']>;
  /** The MarketingStrategy that the site is associated with */
  marketingStrategy?: Maybe<MarketingStrategy>;
  /** The UID of the MarketingStrategy that the site is associated with */
  marketingStrategyId?: Maybe<Scalars['Int']['output']>;
  /** The name of the site */
  name?: Maybe<Scalars['String']['output']>;
  /** The User who owns the site */
  owner?: Maybe<User>;
  /** The PaySubscription that the site is associated with */
  paySubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** The platform the site runs on */
  platform: Scalars['String']['output'];
  /** The site's ID on its platform */
  platformSiteId: Scalars['Int']['output'];
  /** The timestamp when the site was registered */
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Semrush provider project ID for the site */
  semrushProviderProjectId?: Maybe<Scalars['String']['output']>;
  /** The ServiceOrders associated with the site */
  serviceOrders: Array<ServiceOrderGraph>;
  /** Whether the site needs to have its stats updated */
  statsNeedsUpdate: Scalars['Boolean']['output'];
  /** Whether the site is currently updating its stats */
  statsUpdating: Scalars['Boolean']['output'];
  /** The subdomain of the site */
  subdomain?: Maybe<Scalars['String']['output']>;
  /** The target lead type for the site */
  targetLeadType?: Maybe<Scalars['String']['output']>;
  /** TeamMemberBlogRoles for the site (excludes Carrot support-access roles) */
  teamMemberBlogRoles: Array<TeamMemberBlogRole>;
  /** The TeamMembers associated with the site */
  teamMembers: Array<TeamMember>;
  /** The timestamp when the site was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SiteAuditReport = {
  __typename?: 'SiteAuditReport';
  auditCampaign?: Maybe<AuditCampaign>;
  auditSnapshot?: Maybe<AuditSnapshot>;
  auditSnapshots?: Maybe<Array<AuditSnapshot>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type SiteDashboardVisitor = {
  __typename?: 'SiteDashboardVisitor';
  visitorTotalPerSite: Array<TotalVisitorsPerSite>;
};

/** Autogenerated input type of SiteDeactivate */
export type SiteDeactivateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The site's ID on its platform. Only WordPress sites are reachable. */
  platformSiteId: Scalars['Int']['input'];
};

/** Autogenerated return type of SiteDeactivate. */
export type SiteDeactivatePayload = {
  __typename?: 'SiteDeactivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  site?: Maybe<Site>;
};

export type SiteDesign = {
  __typename?: 'SiteDesign';
  /** AI-generated palette options */
  aiPalettes: Array<Palette>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  faviconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Candidate logos found during extraction */
  logoCandidates: Array<LogoCandidate>;
  /** Error message if logo extraction failed */
  logoExtractionError?: Maybe<Scalars['String']['output']>;
  /** Status of logo extraction */
  logoExtractionStatus?: Maybe<Scalars['String']['output']>;
  /** Logo source: uploaded, extracted, or none */
  logoSource: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  marketingStrategyId: Scalars['Int']['output'];
  /** Error message if palette generation failed */
  paletteGenerationError?: Maybe<Scalars['String']['output']>;
  /** Status of palette generation */
  paletteGenerationStatus?: Maybe<Scalars['String']['output']>;
  /** Selected color palette */
  selectedPalette?: Maybe<Palette>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SiteEdit */
export type SiteEditInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  /** The site's ID on its platform. Only WordPress sites are reachable. */
  platformSiteId: Scalars['Int']['input'];
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SiteEdit. */
export type SiteEditPayload = {
  __typename?: 'SiteEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  site?: Maybe<Site>;
};

/** Autogenerated input type of SiteUpdateMappedDomain */
export type SiteUpdateMappedDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  /** The site's ID on its platform. Only WordPress sites are reachable. */
  platformSiteId: Scalars['Int']['input'];
};

/** Autogenerated return type of SiteUpdateMappedDomain. */
export type SiteUpdateMappedDomainPayload = {
  __typename?: 'SiteUpdateMappedDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  site?: Maybe<Site>;
};

export type SiteUsage = {
  __typename?: 'SiteUsage';
  /** Cost in cents of an additional site for the current billing interval */
  additionalSiteCost?: Maybe<Scalars['Int']['output']>;
  /** Number of active sites on the account */
  currentSites: Scalars['Int']['output'];
  /** Number of sites included in the plan */
  includedSites: Scalars['Int']['output'];
  /** Whether adding a site requires a subscription upgrade */
  requiresUpgrade: Scalars['Boolean']['output'];
};

/** Autogenerated input type of StripeBundleCheckout */
export type StripeBundleCheckoutInput = {
  bundleId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StripeBundleCheckout. */
export type StripeBundleCheckoutPayload = {
  __typename?: 'StripeBundleCheckoutPayload';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of StripeCustomerPortal */
export type StripeCustomerPortalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of StripeCustomerPortal. */
export type StripeCustomerPortalPayload = {
  __typename?: 'StripeCustomerPortalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  amountDue?: Maybe<Scalars['Int']['output']>;
  amountPaid?: Maybe<Scalars['Int']['output']>;
  amountRemaining?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<StripeInvoiceLineItem>>;
  lines?: Maybe<Scalars['JSON']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  periodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  periodStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type StripeInvoiceLineItem = {
  __typename?: 'StripeInvoiceLineItem';
  amount: Scalars['Int']['output'];
  amountExcludingTax: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  price: Price;
  quantity: Scalars['Int']['output'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  id: Scalars['String']['output'];
  invoices: Array<StripeInvoice>;
  lineItems: Array<StripeSubscriptionLineItem>;
};

/** Autogenerated input type of StripeSubscriptionCheckout */
export type StripeSubscriptionCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<StripeSubscriptionLineItemInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of StripeSubscriptionCheckout. */
export type StripeSubscriptionCheckoutPayload = {
  __typename?: 'StripeSubscriptionCheckoutPayload';
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type StripeSubscriptionLineItem = {
  __typename?: 'StripeSubscriptionLineItem';
  price?: Maybe<Price>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type StripeSubscriptionLineItemInput = {
  priceId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated input type of SubmitCancellationSurvey */
export type SubmitCancellationSurveyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  posthogSurveyId?: InputMaybe<Scalars['String']['input']>;
  productBeingCanceled?: InputMaybe<Scalars['String']['input']>;
  reasonCategory?: InputMaybe<Scalars['String']['input']>;
  wordpressUserId: Scalars['Int']['input'];
};

/** Autogenerated return type of SubmitCancellationSurvey. */
export type SubmitCancellationSurveyPayload = {
  __typename?: 'SubmitCancellationSurveyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  retentionOffers: Array<RetentionOffer>;
  survey?: Maybe<CancellationSurvey>;
};

/** Autogenerated input type of SyncNow */
export type SyncNowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GBP connection ID */
  gbpConnectionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncNow. */
export type SyncNowPayload = {
  __typename?: 'SyncNowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpConnection?: Maybe<GbpIntegration>;
};

/** Autogenerated input type of SyncWordpressMetadata */
export type SyncWordpressMetadataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of SyncWordpressMetadata. */
export type SyncWordpressMetadataPayload = {
  __typename?: 'SyncWordpressMetadataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success?: Maybe<Scalars['JSON']['output']>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  account?: Maybe<Account>;
  accountRole: Scalars['String']['output'];
  blogRoles: Array<TeamMemberBlogRole>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmSeat: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inviteEmail: Scalars['String']['output'];
  pending: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  uuid: Scalars['String']['output'];
};

/** Autogenerated input type of TeamMemberAcceptInvite */
export type TeamMemberAcceptInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of TeamMemberAcceptInvite. */
export type TeamMemberAcceptInvitePayload = {
  __typename?: 'TeamMemberAcceptInvitePayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TeamMemberAddToAccount */
export type TeamMemberAddToAccountInput = {
  accountId: Scalars['Int']['input'];
  accountRole: Scalars['String']['input'];
  blogRoles: Array<TeamMemberBlogRoleInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmSeat: Scalars['Boolean']['input'];
  inviteEmail: Scalars['String']['input'];
};

/** Autogenerated return type of TeamMemberAddToAccount. */
export type TeamMemberAddToAccountPayload = {
  __typename?: 'TeamMemberAddToAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  teamMember?: Maybe<TeamMember>;
};

export type TeamMemberBlogRole = {
  __typename?: 'TeamMemberBlogRole';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  role: TeamMemberBlogRoleValue;
  site: Site;
  siteId: Scalars['Int']['output'];
  teamMember: TeamMember;
  teamMemberId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use site. */
  wpBlog: WpBlog;
  /** @deprecated Use siteId. */
  wpBlogId: Scalars['Int']['output'];
};

export type TeamMemberBlogRoleInput = {
  /** The site's ID on its platform. Only WordPress sites are reachable. */
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  role: Scalars['String']['input'];
  /** @deprecated Use platformSiteId. */
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of TeamMemberBlogRoleUpdate */
export type TeamMemberBlogRoleUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The site's ID on its platform. Only WordPress sites are reachable. */
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
  role: TeamMemberBlogRoleValue;
  teamMemberId: Scalars['Int']['input'];
  /** @deprecated Use platformSiteId. */
  wordpressBlogId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of TeamMemberBlogRoleUpdate. */
export type TeamMemberBlogRoleUpdatePayload = {
  __typename?: 'TeamMemberBlogRoleUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

export enum TeamMemberBlogRoleValue {
  Administrator = 'administrator',
  Author = 'author',
  Editor = 'editor',
  None = 'none'
}

/** Autogenerated input type of TeamMemberDelete */
export type TeamMemberDeleteInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamMemberId: Scalars['Int']['input'];
};

/** Autogenerated return type of TeamMemberDelete. */
export type TeamMemberDeletePayload = {
  __typename?: 'TeamMemberDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of TeamMemberEdit */
export type TeamMemberEditInput = {
  accountId: Scalars['Int']['input'];
  accountRole: Scalars['String']['input'];
  blogRoles: Array<TeamMemberBlogRoleInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmSeat: Scalars['Boolean']['input'];
  teamMemberId: Scalars['Int']['input'];
};

/** Autogenerated return type of TeamMemberEdit. */
export type TeamMemberEditPayload = {
  __typename?: 'TeamMemberEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  teamMember?: Maybe<TeamMember>;
};

/** Autogenerated input type of ToggleBlockedNumber */
export type ToggleBlockedNumberInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  spam: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ToggleBlockedNumber. */
export type ToggleBlockedNumberPayload = {
  __typename?: 'ToggleBlockedNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

export type TopPagesReport = {
  __typename?: 'TopPagesReport';
  avgEngagementTimePerSession?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Int']['output'];
  page: Scalars['String']['output'];
  pageViewsPerVisitor?: Maybe<Scalars['Float']['output']>;
  visitors: Scalars['Int']['output'];
};

export type TotalVisitorsPerSite = {
  __typename?: 'TotalVisitorsPerSite';
  previousVisitors?: Maybe<Scalars['Int']['output']>;
  subdomain?: Maybe<Scalars['String']['output']>;
  visitors?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of TrackSignup */
export type TrackSignupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  tid: Scalars['String']['input'];
};

/** Autogenerated return type of TrackSignup. */
export type TrackSignupPayload = {
  __typename?: 'TrackSignupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success?: Maybe<Scalars['JSON']['output']>;
};

export type TrafficAndLeadsDataPoints = {
  __typename?: 'TrafficAndLeadsDataPoints';
  count?: Maybe<Scalars['Int']['output']>;
  date: Scalars['ISO8601Date']['output'];
};

export type TrafficAndLeadsReport = {
  __typename?: 'TrafficAndLeadsReport';
  leads: Array<TrafficAndLeadsDataPoints>;
  totals: TrafficAndLeadsTotals;
  visitors: Array<TrafficAndLeadsDataPoints>;
};

export type TrafficAndLeadsTotals = {
  __typename?: 'TrafficAndLeadsTotals';
  avgSessionTime?: Maybe<Scalars['Float']['output']>;
  avgSessionTimeChange?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversionRateChange?: Maybe<Scalars['Float']['output']>;
  leadsTotal: Scalars['Float']['output'];
  leadsTotalChange?: Maybe<Scalars['Float']['output']>;
  mobileUsage?: Maybe<Scalars['Float']['output']>;
  visitorsTotal: Scalars['Float']['output'];
  visitorsTotalChange?: Maybe<Scalars['Float']['output']>;
};

export type TrafficSourceReport = {
  __typename?: 'TrafficSourceReport';
  avgEngagementRate?: Maybe<Scalars['Float']['output']>;
  avgEngagementTimePerSession?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  conversions: Scalars['Int']['output'];
  eventCount?: Maybe<Scalars['Float']['output']>;
  pageViewsPerVisitor?: Maybe<Scalars['Float']['output']>;
  source: Scalars['String']['output'];
  visitors: Scalars['Int']['output'];
};

export type TwilioApiPhoneNumber = {
  __typename?: 'TwilioApiPhoneNumber';
  isoCountry?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type TwilioCall = {
  __typename?: 'TwilioCall';
  actionItems?: Maybe<Array<Scalars['String']['output']>>;
  answeredBy?: Maybe<Scalars['String']['output']>;
  callScore?: Maybe<Scalars['Int']['output']>;
  callScoreReasoning?: Maybe<Scalars['String']['output']>;
  callStatus?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  childCall?: Maybe<TwilioCall>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmOpportunityId?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  fromNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  parentCall?: Maybe<TwilioCall>;
  parentCallId?: Maybe<Scalars['Int']['output']>;
  recordingTwilioId?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  spam: Scalars['Boolean']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  toNumber?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Array<Scalars['String']['output']>>;
  twilioId: Scalars['String']['output'];
  twilioSubaccountId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TwilioNumber = {
  __typename?: 'TwilioNumber';
  active: Scalars['Boolean']['output'];
  campaign?: Maybe<Campaign>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  forwardToNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  twilioId?: Maybe<Scalars['String']['output']>;
  twilioSubaccountId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TwilioSubaccount = {
  __typename?: 'TwilioSubaccount';
  accountId?: Maybe<Scalars['Int']['output']>;
  callTrackingNumbers: Array<TwilioNumber>;
  calls: Array<TwilioCall>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  texts: Array<TwilioText>;
  twilioDateCreated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twilioDateUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  twilioId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of TwilioSubaccountCreate */
export type TwilioSubaccountCreateInput = {
  accountId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TwilioSubaccountCreate. */
export type TwilioSubaccountCreatePayload = {
  __typename?: 'TwilioSubaccountCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  twilioSubaccount?: Maybe<TwilioSubaccount>;
};

export type TwilioText = {
  __typename?: 'TwilioText';
  campaignId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crmOpportunityId?: Maybe<Scalars['String']['output']>;
  fromNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  receivedTime: Scalars['ISO8601DateTime']['output'];
  spam: Scalars['Boolean']['output'];
  toNumber?: Maybe<Scalars['String']['output']>;
  twilioId: Scalars['String']['output'];
  twilioSubaccountId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of UnhideAllSiteAuditReportIssueDetails */
export type UnhideAllSiteAuditReportIssueDetailsInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['Int']['input'];
};

/** Autogenerated return type of UnhideAllSiteAuditReportIssueDetails. */
export type UnhideAllSiteAuditReportIssueDetailsPayload = {
  __typename?: 'UnhideAllSiteAuditReportIssueDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnhideAllSiteAuditReportIssues */
export type UnhideAllSiteAuditReportIssuesInput = {
  auditSnapshotId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnhideAllSiteAuditReportIssues. */
export type UnhideAllSiteAuditReportIssuesPayload = {
  __typename?: 'UnhideAllSiteAuditReportIssuesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpcomingInvoicePreview = {
  __typename?: 'UpcomingInvoicePreview';
  invoice: StripeInvoice;
  lineItems: Array<StripeInvoiceLineItem>;
};

/** Autogenerated input type of UpdateFeature */
export type UpdateFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFeature. */
export type UpdateFeaturePayload = {
  __typename?: 'UpdateFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feature?: Maybe<Feature>;
};

/** Autogenerated input type of UpdateProfile */
export type UpdateProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GBP connection ID */
  gbpConnectionId: Scalars['ID']['input'];
  /** Profile fields to update */
  input: GbpProfileInput;
};

/** Autogenerated return type of UpdateProfile. */
export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  gbpProfile?: Maybe<GbpProfile>;
};

/** Autogenerated input type of UpdateSubscription */
export type UpdateSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  couponId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<PriceQuantity>>;
  offerType?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateSubscription. */
export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  portalUrl: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  epic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  superAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  vip?: InputMaybe<Scalars['Boolean']['input']>;
  wordpressUserId: Scalars['Int']['input'];
  wordpressUsername?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpgradeContentProToStandard */
export type UpgradeContentProToStandardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpgradeContentProToStandard. */
export type UpgradeContentProToStandardPayload = {
  __typename?: 'UpgradeContentProToStandardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UpsertBusinessOnboarding */
export type UpsertBusinessOnboardingInput = {
  accountId: Scalars['Int']['input'];
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  addressZip?: InputMaybe<Scalars['String']['input']>;
  budgetBand?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crmName?: InputMaybe<Scalars['String']['input']>;
  hasCrm?: InputMaybe<Scalars['Boolean']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpsertBusinessOnboarding. */
export type UpsertBusinessOnboardingPayload = {
  __typename?: 'UpsertBusinessOnboardingPayload';
  businessOnboarding?: Maybe<BusinessOnboarding>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<UserInputError>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpsertFeature */
export type UpsertFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  productFeatures: Array<ProductFeatureInput>;
};

/** Autogenerated return type of UpsertFeature. */
export type UpsertFeaturePayload = {
  __typename?: 'UpsertFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  feature: Feature;
};

/** Autogenerated input type of UpsertMarketingStrategy */
export type UpsertMarketingStrategyInput = {
  accountId: Scalars['Int']['input'];
  businessText?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  crawlActorId?: InputMaybe<Scalars['String']['input']>;
  crawlDatasetId?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Array<Scalars['String']['input']>>;
  externalSite?: InputMaybe<Scalars['String']['input']>;
  idealClient?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId?: InputMaybe<Scalars['Int']['input']>;
  mission?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationwide?: InputMaybe<Scalars['Boolean']['input']>;
  problemSolved?: InputMaybe<Scalars['String']['input']>;
  serviceAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  startReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  successMetrics?: InputMaybe<Array<Scalars['String']['input']>>;
  successStories?: InputMaybe<Array<Scalars['String']['input']>>;
  tone?: InputMaybe<Array<Scalars['String']['input']>>;
  uniquePromise?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpsertMarketingStrategy. */
export type UpsertMarketingStrategyPayload = {
  __typename?: 'UpsertMarketingStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  marketingStrategy?: Maybe<MarketingStrategy>;
};

export type User = {
  __typename?: 'User';
  abilities: Array<Ability>;
  account?: Maybe<Account>;
  accounts: Array<Account>;
  /** @deprecated We plan to move to URL-based account selection. */
  activeAccount?: Maybe<Account>;
  carrotAccountStatus: Scalars['String']['output'];
  carrotCrmConfig?: Maybe<CarrotCrmConfig>;
  carrotVersion?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentSubscription?: Maybe<PaySubscription>;
  dashboardOptInState: Scalars['String']['output'];
  email: Scalars['String']['output'];
  epic: Scalars['Boolean']['output'];
  googleAuthConfigs?: Maybe<GoogleAuthConfig>;
  id: Scalars['Int']['output'];
  lastSubscription?: Maybe<PaySubscription>;
  migratedFrom?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboarding?: Maybe<Onboarding>;
  paySubscriptions: Array<PaySubscription>;
  sites: Array<Site>;
  stripeSubscription?: Maybe<StripeSubscription>;
  superAdmin?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vip: Scalars['Boolean']['output'];
  wordpressUserId: Scalars['Int']['output'];
  wordpressUsername: Scalars['String']['output'];
  /** @deprecated Use sites. */
  wpBlogs: Array<WpBlog>;
};

/** A user-readable error */
export type UserInputError = {
  __typename?: 'UserInputError';
  /** A machine-readable error code for programmatic handling */
  code?: Maybe<Scalars['String']['output']>;
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type WordpressUserMeta = {
  __typename?: 'WordpressUserMeta';
  error?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
};

export type WpBlog = {
  __typename?: 'WpBlog';
  /** The ID of the account that owns the site */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** The name of the account that owns the site */
  accountName?: Maybe<Scalars['String']['output']>;
  /** The ActionItems associated with the site */
  actionItems: Array<ActionItem>;
  /** A boolean indicating whether the site is archived */
  archived: Scalars['Boolean']['output'];
  /** The site's Semrush backlink overviews */
  backlinkOverviews: Array<WpBlogBacklinkOverview>;
  /** Whether the site uses a block theme */
  blockTheme?: Maybe<Scalars['Boolean']['output']>;
  /** The category of the site */
  category?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the site was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** A boolean indicating whether the site is deleted */
  deleted: Scalars['Boolean']['output'];
  /** The site's Semrush domain overview history */
  domainOverviewHistories: Array<WpBlogDomainOverviewHistory>;
  /** The GoogleAuthConfig that the site is associated with */
  googleAuthConfig?: Maybe<GoogleAuthConfig>;
  /** The UID of the GoogleAuthConfig that the site is associated with */
  googleAuthConfigId?: Maybe<Scalars['Int']['output']>;
  /** The GoogleSiteVerification record for this site */
  googleSiteVerification?: Maybe<GoogleSiteVerification>;
  /** The UID of the site */
  id: Scalars['Int']['output'];
  /** The domain that a User has mapped to the site */
  mappedDomain?: Maybe<Scalars['String']['output']>;
  /** The MarketingStrategy that the site is associated with */
  marketingStrategy?: Maybe<MarketingStrategy>;
  /** The UID of the MarketingStrategy that the site is associated with */
  marketingStrategyId?: Maybe<Scalars['Int']['output']>;
  /** The name of the site */
  name?: Maybe<Scalars['String']['output']>;
  /** The User who owns the site */
  owner?: Maybe<User>;
  /** The PaySubscription that the site is associated with */
  paySubscriptionId?: Maybe<Scalars['Int']['output']>;
  /** The platform the site runs on */
  platform: Scalars['String']['output'];
  /** The site's ID on its platform */
  platformSiteId: Scalars['Int']['output'];
  /** The timestamp when the site was registered */
  registeredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Semrush provider project ID for the site */
  semrushProviderProjectId?: Maybe<Scalars['String']['output']>;
  /** The ServiceOrders associated with the site */
  serviceOrders: Array<ServiceOrderGraph>;
  /** Whether the site needs to have its stats updated */
  statsNeedsUpdate: Scalars['Boolean']['output'];
  /** Whether the site is currently updating its stats */
  statsUpdating: Scalars['Boolean']['output'];
  /** The subdomain of the site */
  subdomain?: Maybe<Scalars['String']['output']>;
  /** The target lead type for the site */
  targetLeadType?: Maybe<Scalars['String']['output']>;
  /** TeamMemberBlogRoles for the site (excludes Carrot support-access roles) */
  teamMemberBlogRoles: Array<TeamMemberBlogRole>;
  /** The TeamMembers associated with the site */
  teamMembers: Array<TeamMember>;
  /** The timestamp when the site was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * The WordPress ID of the site
   * @deprecated Use platformSiteId.
   */
  wordpressBlogId: Scalars['Int']['output'];
  /** @deprecated Use Site.backlinkOverviews. */
  wpBlogBacklinkOverviews: Array<WpBlogBacklinkOverview>;
  /** @deprecated Use Site.domainOverviewHistories. */
  wpBlogDomainOverviewHistories: Array<WpBlogDomainOverviewHistory>;
};

export type WpBlogBacklink = {
  __typename?: 'WpBlogBacklink';
  anchor?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  externalNum: Scalars['Int']['output'];
  firstSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  form: Scalars['Boolean']['output'];
  frame: Scalars['Boolean']['output'];
  image: Scalars['Boolean']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  internalNum: Scalars['Int']['output'];
  lastSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lostlink: Scalars['Boolean']['output'];
  newlink: Scalars['Boolean']['output'];
  nofollow: Scalars['Boolean']['output'];
  pageAscore: Scalars['Int']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  sitewide: Scalars['Boolean']['output'];
  sourceSize?: Maybe<Scalars['Int']['output']>;
  sourceTitle?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  targetTitle?: Maybe<Scalars['String']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WpBlogBacklinkOverview = {
  __typename?: 'WpBlogBacklinkOverview';
  authorityScore: Scalars['Int']['output'];
  backlinkTotal: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  followed: Scalars['Int']['output'];
  form: Scalars['Int']['output'];
  frame: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['Int']['output'];
  ipClassic: Scalars['Int']['output'];
  ips: Scalars['Int']['output'];
  notFollowed: Scalars['Int']['output'];
  referringDomainTotal: Scalars['Int']['output'];
  referringDomains: Scalars['Int']['output'];
  siteId: Scalars['Int']['output'];
  sponsored: Scalars['Int']['output'];
  text: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userGeneratedContent: Scalars['Int']['output'];
  /** @deprecated Use siteId. */
  wpBlogId: Scalars['Int']['output'];
};

export type WpBlogBacklinkOverviewChanges = {
  __typename?: 'WpBlogBacklinkOverviewChanges';
  authorityScoreChange?: Maybe<Scalars['Float']['output']>;
  referringDomainsChange?: Maybe<Scalars['Float']['output']>;
  totalChange?: Maybe<Scalars['Float']['output']>;
};

export type WpBlogBacklinkUpsell = {
  __typename?: 'WpBlogBacklinkUpsell';
  authorityScore: Scalars['Int']['output'];
  backlinks?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  siteId: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use siteId. */
  wpBlogId: Scalars['Int']['output'];
};

/** Autogenerated input type of WpBlogCreate */
export type WpBlogCreateInput = {
  blogId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['Int']['input'];
  registeredAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subdomain: Scalars['String']['input'];
  targetLeadType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WpBlogCreate. */
export type WpBlogCreatePayload = {
  __typename?: 'WpBlogCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated input type of WpBlogDeactivate */
export type WpBlogDeactivateInput = {
  blogId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WpBlogDeactivate. */
export type WpBlogDeactivatePayload = {
  __typename?: 'WpBlogDeactivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

export type WpBlogDomainOverviewHistory = {
  __typename?: 'WpBlogDomainOverviewHistory';
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  keywordsEightyOneToNinety: Scalars['Int']['output'];
  keywordsElevenToTwenty: Scalars['Int']['output'];
  keywordsFiftyOneToSixty: Scalars['Int']['output'];
  keywordsFortyOneToFifty: Scalars['Int']['output'];
  keywordsFourToTen: Scalars['Int']['output'];
  keywordsNinetyOneAndUp: Scalars['Int']['output'];
  keywordsOneToThree: Scalars['Int']['output'];
  keywordsSeventyOneToEighty: Scalars['Int']['output'];
  keywordsSixtyOneToSeventy: Scalars['Int']['output'];
  keywordsThirtyOneToForty: Scalars['Int']['output'];
  keywordsTwentyOneToThirty: Scalars['Int']['output'];
  organicTraffic: Scalars['Int']['output'];
  siteId: Scalars['Int']['output'];
  totalKeywords: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** @deprecated Use siteId. */
  wpBlogId: Scalars['Int']['output'];
};

/** Autogenerated input type of WpBlogEdit */
export type WpBlogEditInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  blogId: Scalars['Int']['input'];
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WpBlogEdit. */
export type WpBlogEditPayload = {
  __typename?: 'WpBlogEditPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated input type of WpBlogUpdate */
export type WpBlogUpdateInput = {
  archived: Scalars['Boolean']['input'];
  blogId: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deleted: Scalars['Boolean']['input'];
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
  marketingStrategyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['Int']['input'];
  subdomain: Scalars['String']['input'];
  targetLeadType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of WpBlogUpdateMappedDomain */
export type WpBlogUpdateMappedDomainInput = {
  blogId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mappedDomain?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WpBlogUpdateMappedDomain. */
export type WpBlogUpdateMappedDomainPayload = {
  __typename?: 'WpBlogUpdateMappedDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

/** Autogenerated return type of WpBlogUpdate. */
export type WpBlogUpdatePayload = {
  __typename?: 'WpBlogUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  wpBlog?: Maybe<WpBlog>;
};

export type HubspotTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type HubspotTokenQuery = { __typename?: 'Query', hubspotToken: string };

export type AmGraphQlTestQueryQueryVariables = Exact<{
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AmGraphQlTestQueryQuery = { __typename?: 'Query', site?: { __typename?: 'Site', subdomain?: string | null } | null };

export type AmInfiniteTestQueryQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type AmInfiniteTestQueryQuery = { __typename?: 'Query', backlinkReport: Array<{ __typename?: 'WpBlogBacklink', sourceTitle?: string | null }> };

export type AmGraphQlTestMutationMutationVariables = Exact<{
  input: StripeCustomerPortalInput;
}>;


export type AmGraphQlTestMutationMutation = { __typename?: 'Mutation', stripeCustomerPortal?: { __typename?: 'StripeCustomerPortalPayload', url?: string | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type SiteQueryVariables = Exact<{
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SiteQuery = { __typename?: 'Query', site?: { __typename?: 'Site', platformSiteId: number, subdomain?: string | null, mappedDomain?: string | null, category?: string | null, registeredAt?: string | null, blockTheme?: boolean | null, accountId?: number | null, marketingStrategyId?: number | null, semrushProviderProjectId?: string | null, owner?: { __typename?: 'User', wordpressUserId: number, wordpressUsername: string } | null, googleAuthConfig?: { __typename?: 'GoogleAuthConfig', id: number } | null } | null };

export type AccountQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: number, name: string, isAgency: boolean, onboardingStatus?: OnboardingStatus | null, owner: { __typename?: 'User', carrotAccountStatus: string, carrotCrmConfig?: { __typename?: 'CarrotCrmConfig', teamId: string } | null }, agency?: { __typename?: 'Agency', account: { __typename?: 'Account', id: number } } | null, paySubscription?: { __typename?: 'PaySubscription', usage: any, limits: any } | null, sites?: Array<{ __typename?: 'Site', id: number, name?: string | null, platformSiteId: number, mappedDomain?: string | null, subdomain?: string | null, category?: string | null, registeredAt?: string | null, blockTheme?: boolean | null, owner?: { __typename?: 'User', wordpressUserId: number, wordpressUsername: string } | null }> | null, twilioSubaccount?: { __typename?: 'TwilioSubaccount', id: number } | null } };

export type CurrentUserQueryVariables = Exact<{
  wordpressUserId: Scalars['Int']['input'];
}>;


export type CurrentUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: number, carrotAccountStatus: string, carrotVersion?: number | null, dashboardOptInState: string, name?: string | null, email: string, createdAt: string, wordpressUserId: number, wordpressUsername: string, superAdmin?: boolean | null, vip: boolean, activeAccount?: { __typename?: 'Account', id: number, owner: { __typename?: 'User', name?: string | null, carrotAccountStatus: string, carrotCrmConfig?: { __typename?: 'CarrotCrmConfig', id: number, teamId: string } | null } } | null, account?: { __typename?: 'Account', id: number } | null, accounts: Array<{ __typename?: 'Account', id: number, name: string, isAgency: boolean }>, currentSubscription?: { __typename?: 'PaySubscription', status: string, canceledAt?: string | null, pastDueDate?: string | null, pastDueCancelAtDate?: string | null, pendingCancellation: boolean, discount?: { __typename?: 'PaySubscriptionDiscount', endDate?: number | null, startDate: number, coupon: { __typename?: 'Coupon', name?: string | null, duration?: string | null, percentOff?: number | null, amountOff?: number | null } } | null, starter: { __typename?: 'Price', id: number, active: boolean, customerType?: string | null, interval?: string | null, wordpressLabel?: string | null, version?: number | null, product: { __typename?: 'Product', name: string, starter?: boolean | null, group?: string | null } }, items: Array<{ __typename?: 'PaySubscriptionItem', quantity: number, price: { __typename?: 'Price', id: number, active: boolean, amount: number, wordpressLabel?: string | null, version?: number | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } } }> } | null } | null };

export type StripeCustomerPortalMutationVariables = Exact<{
  input: StripeCustomerPortalInput;
}>;


export type StripeCustomerPortalMutation = { __typename?: 'Mutation', stripeCustomerPortal?: { __typename?: 'StripeCustomerPortalPayload', url?: string | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type TeamMemberAbilitiesQueryVariables = Exact<{
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  platformSiteId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TeamMemberAbilitiesQuery = { __typename?: 'Query', teamMemberAbility?: Array<{ __typename?: 'Ability', action: Array<string>, subject: Array<string>, limitingIds?: Array<number> | null }> | null };

export type AgencyClientsQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type AgencyClientsQuery = { __typename?: 'Query', agencyClientAccounts: Array<{ __typename?: 'Account', id: number, name: string, onboardingStatus?: OnboardingStatus | null, sites?: Array<{ __typename?: 'Site', id: number, name?: string | null, subdomain?: string | null, mappedDomain?: string | null }> | null }> };

export type AgencyAddClientMutationVariables = Exact<{
  input: AddClientInput;
}>;


export type AgencyAddClientMutation = { __typename?: 'Mutation', agencyAddClient?: { __typename?: 'AddClientPayload', account?: { __typename?: 'Account', id: number } | null, errors: Array<{ __typename?: 'UserInputError', message: string, path?: Array<string> | null }> } | null };

export type TrafficAndLeadsReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrafficAndLeadsReportQuery = { __typename?: 'Query', trafficAndLeadsReport: { __typename?: 'TrafficAndLeadsReport', totals: { __typename?: 'TrafficAndLeadsTotals', visitorsTotal: number, visitorsTotalChange?: number | null, leadsTotal: number, leadsTotalChange?: number | null, conversionRate?: number | null, conversionRateChange?: number | null, avgSessionTime?: number | null, avgSessionTimeChange?: number | null, mobileUsage?: number | null }, leads: Array<{ __typename?: 'TrafficAndLeadsDataPoints', date: any, count?: number | null }>, visitors: Array<{ __typename?: 'TrafficAndLeadsDataPoints', date: any, count?: number | null }> } };

export type LandingPageReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LandingPageReportQuery = { __typename?: 'Query', landingPageReport: Array<{ __typename?: 'LandingPageReport', landingPage: string, visitors: number, pageViewsPerVisitor?: number | null, avgEngagementTimePerSession?: number | null, conversions: number, conversionRate?: number | null }> };

export type TrafficSourceReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrafficSourceReportQuery = { __typename?: 'Query', trafficSourceReport: Array<{ __typename?: 'TrafficSourceReport', source: string, visitors: number }> };

export type BacklinkAnalysisQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
}>;


export type BacklinkAnalysisQuery = { __typename?: 'Query', backlinkProfileReport: { __typename?: 'BacklinkProfileReport', backlinkOverview?: { __typename?: 'WpBlogBacklinkOverview', total: number, authorityScore: number, referringDomains: number } | null, backlinkOverviewChanges?: { __typename?: 'WpBlogBacklinkOverviewChanges', totalChange?: number | null, authorityScoreChange?: number | null, referringDomainsChange?: number | null } | null }, backlinkCategoryReport?: { __typename?: 'WpBlogBacklinkOverview', followed: number, notFollowed: number, sponsored: number, userGeneratedContent: number, text: number, image: number, form: number, frame: number, referringDomainTotal: number, backlinkTotal: number } | null };

export type BacklinksOverTimeQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BacklinksOverTimeQuery = { __typename?: 'Query', backlinkOverviewReport: Array<{ __typename?: 'WpBlogBacklinkOverview', total: number, date: any }> };

export type BacklinkReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type BacklinkReportQuery = { __typename?: 'Query', backlinkReport: Array<{ __typename?: 'WpBlogBacklink', pageAscore: number, sourceTitle?: string | null, sourceUrl?: string | null, anchor?: string | null, targetUrl?: string | null, nofollow: boolean, form: boolean, frame: boolean, image: boolean, sitewide: boolean, newlink: boolean, lostlink: boolean, externalNum: number, internalNum: number, firstSeen?: string | null, lastSeen?: string | null }> };

export type BacklinkUpsellReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
}>;


export type BacklinkUpsellReportQuery = { __typename?: 'Query', siteBacklinkUpsellReport?: { __typename?: 'WpBlogBacklinkUpsell', authorityScore: number, backlinks?: any | null } | null };

export type MembershipManagementQueryVariables = Exact<{
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MembershipManagementQuery = { __typename?: 'Query', membershipManagement?: { __typename?: 'MembershipManagement', balance?: number | null, customerPortalUrl?: string | null, cancellationRequestLink?: string | null, paySubscription?: { __typename?: 'PaySubscription', currentPeriodEnd?: string | null, limits: any, usage: any, status: string, items: Array<{ __typename?: 'PaySubscriptionItem', quantity: number, price: { __typename?: 'Price', active: boolean, amount: number, customerType?: string | null, interval?: string | null, version?: number | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } } }>, discount?: { __typename?: 'PaySubscriptionDiscount', endDate?: number | null, coupon: { __typename?: 'Coupon', name?: string | null, percentOff?: number | null, amountOff?: number | null } } | null } | null, payPaymentMethod?: { __typename?: 'PayPaymentMethod', data?: any | null, type?: string | null, billingDetails?: any | null } | null } | null };

export type SubscriptionInvoicePreviewQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  subscriptionType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubscriptionInvoicePreviewQuery = { __typename?: 'Query', subscriptionInvoicePreview?: { __typename?: 'StripeInvoice', lineItems?: Array<{ __typename?: 'StripeInvoiceLineItem', amount: number, quantity: number, price: { __typename?: 'Price', product: { __typename?: 'Product', name: string } } }> | null } | null };

export type CancelSubscriptionAtPeriodEndMutationVariables = Exact<{
  input: CancelSubscriptionAtPeriodEndInput;
}>;


export type CancelSubscriptionAtPeriodEndMutation = { __typename?: 'Mutation', cancelSubscriptionAtPeriodEnd?: { __typename?: 'CancelSubscriptionAtPeriodEndPayload', success?: boolean | null, errors: Array<{ __typename?: 'UserInputError', message: string, path?: Array<string> | null }> } | null };

export type ToggleBlockedNumberMutationVariables = Exact<{
  input: ToggleBlockedNumberInput;
}>;


export type ToggleBlockedNumberMutation = { __typename?: 'Mutation', toggleBlockedNumber?: { __typename?: 'ToggleBlockedNumberPayload', success: boolean, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type SiteEditMutationVariables = Exact<{
  input: SiteEditInput;
}>;


export type SiteEditMutation = { __typename?: 'Mutation', siteEdit?: { __typename?: 'SiteEditPayload', errors: Array<string>, site?: { __typename?: 'Site', platformSiteId: number } | null } | null };

export type CampaignEditMutationVariables = Exact<{
  input: CampaignEditInput;
}>;


export type CampaignEditMutation = { __typename?: 'Mutation', campaignEdit?: { __typename?: 'CampaignEditPayload', campaign: { __typename?: 'Campaign', name?: string | null } } | null };

export type TwilioSubaccountCreateMutationVariables = Exact<{
  input: TwilioSubaccountCreateInput;
}>;


export type TwilioSubaccountCreateMutation = { __typename?: 'Mutation', twilioSubaccountCreate?: { __typename?: 'TwilioSubaccountCreatePayload', twilioSubaccount?: { __typename?: 'TwilioSubaccount', id: number } | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type AvailableNumbersQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
  areaCode: Scalars['String']['input'];
}>;


export type AvailableNumbersQuery = { __typename?: 'Query', availablePhoneNumbers?: Array<{ __typename?: 'TwilioApiPhoneNumber', phoneNumber: string, locality?: string | null, region?: string | null }> | null };

export type BuyPhoneNumberMutationVariables = Exact<{
  input: PhoneNumberBuyInput;
}>;


export type BuyPhoneNumberMutation = { __typename?: 'Mutation', buyPhoneNumber?: { __typename?: 'PhoneNumberBuyPayload', phoneNumber?: { __typename?: 'TwilioNumber', id: number, campaign?: { __typename?: 'Campaign', id: number } | null } | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type SearchCodeSuggestionsQueryVariables = Exact<{
  code: Scalars['String']['input'];
  codeType: Scalars['String']['input'];
}>;


export type SearchCodeSuggestionsQuery = { __typename?: 'Query', searchCodeSuggestions?: { __typename?: 'SearchCodeSuggestions', areaCodes?: Array<string> | null, zipCodes?: Array<string> | null } | null };

export type PhoneNumberDestroyMutationVariables = Exact<{
  input: PhoneNumberDestroyInput;
}>;


export type PhoneNumberDestroyMutation = { __typename?: 'Mutation', phoneNumberDestroy?: { __typename?: 'PhoneNumberDestroyPayload', success: boolean, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type CallTrackingQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type CallTrackingQuery = { __typename?: 'Query', account: { __typename?: 'Account', campaigns?: Array<{ __typename?: 'Campaign', id: number, name?: string | null, site?: { __typename?: 'Site', platformSiteId: number, mappedDomain?: string | null, subdomain?: string | null } | null }> | null, twilioSubaccount?: { __typename?: 'TwilioSubaccount', callTrackingNumbers: Array<{ __typename?: 'TwilioNumber', id: number, active: boolean, phoneNumber: string, forwardToNumber?: string | null, locality?: string | null, region?: string | null, campaign?: { __typename?: 'Campaign', id: number } | null }>, calls: Array<{ __typename: 'TwilioCall', id: number, campaignId?: number | null, startTime: string, callStatus?: string | null, fromNumber: string, toNumber?: string | null, durationInSeconds?: number | null, callScore?: number | null, callScoreReasoning?: string | null, summary?: string | null, transcript?: Array<string> | null, actionItems?: Array<string> | null, crmOpportunityId?: string | null, recordingUrl?: string | null, spam: boolean }>, texts: Array<{ __typename: 'TwilioText', id: number, campaignId?: number | null, receivedTime: string, fromNumber: string, toNumber?: string | null, crmOpportunityId?: string | null, message?: string | null, spam: boolean }> } | null } };

export type PhoneNumberEditMutationVariables = Exact<{
  input: PhoneNumberEditInput;
}>;


export type PhoneNumberEditMutation = { __typename?: 'Mutation', phoneNumberEdit?: { __typename?: 'PhoneNumberEditPayload', phoneNumber?: { __typename?: 'TwilioNumber', phoneNumber: string } | null, errors: Array<{ __typename?: 'UserInputError', message: string }> } | null };

export type SubmitCancellationSurveyMutationVariables = Exact<{
  input: SubmitCancellationSurveyInput;
}>;


export type SubmitCancellationSurveyMutation = { __typename?: 'Mutation', submitCancellationSurvey?: { __typename?: 'SubmitCancellationSurveyPayload', survey?: { __typename?: 'CancellationSurvey', id: number, posthogSurveyId?: string | null, refundEligible?: boolean | null, reasonCategory?: string | null, productBeingCanceled?: string | null, offerAccepted?: string | null, finalOutcome?: string | null } | null, retentionOffers: Array<{ __typename?: 'RetentionOffer', type: string, label: string, pauseDurationMonths?: number | null, targetProductSlug?: string | null, discountPercent?: number | null, durationMonths?: number | null, couponProcessorId?: string | null }>, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type PauseSubscriptionMutationVariables = Exact<{
  input: PauseSubscriptionInput;
}>;


export type PauseSubscriptionMutation = { __typename?: 'Mutation', pauseSubscription?: { __typename?: 'PauseSubscriptionPayload', survey?: { __typename?: 'CancellationSurvey', id: number, offerAccepted?: string | null, finalOutcome?: string | null } | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type PauseStatusQueryVariables = Exact<{
  wordpressUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PauseStatusQuery = { __typename?: 'Query', membershipManagement?: { __typename?: 'MembershipManagement', paySubscription?: { __typename?: 'PaySubscription', discount?: { __typename?: 'PaySubscriptionDiscount', coupon: { __typename?: 'Coupon', name?: string | null } } | null } | null } | null };

export type LatestInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestInvoiceQuery = { __typename?: 'Query', latestInvoice?: { __typename?: 'PayCharge', invoiceId?: string | null, amount: number, items?: Array<{ __typename?: 'StripeInvoiceLineItem', price: { __typename?: 'Price', customerType?: string | null, interval?: string | null, wordpressLabel?: string | null, product: { __typename?: 'Product', name: string, starter?: boolean | null } } }> | null } | null };

export type DomainOverviewQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
}>;


export type DomainOverviewQuery = { __typename?: 'Query', backlinkProfileReport: { __typename?: 'BacklinkProfileReport', backlinkOverview?: { __typename?: 'WpBlogBacklinkOverview', total: number, authorityScore: number, referringDomains: number } | null, backlinkOverviewChanges?: { __typename?: 'WpBlogBacklinkOverviewChanges', totalChange?: number | null, authorityScoreChange?: number | null, referringDomainsChange?: number | null } | null }, backlinkCategoryReport?: { __typename?: 'WpBlogBacklinkOverview', followed: number, notFollowed: number, sponsored: number, userGeneratedContent: number, text: number, image: number, form: number, frame: number, referringDomainTotal: number, backlinkTotal: number } | null, organicProfileReport?: { __typename?: 'OrganicProfileReport', keywords: number, keywordsChange?: number | null, organicVisitors: number, organicVisitorsChange?: number | null } | null };

export type OrganicOverviewReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganicOverviewReportQuery = { __typename?: 'Query', organicOverviewReport: { __typename?: 'OrganicOverviewReport', domainOverviewHistories?: Array<{ __typename?: 'WpBlogDomainOverviewHistory', date: any, keywordsOneToThree: number, keywordsFourToTen: number, keywordsElevenToTwenty: number, keywordsTwentyOneToThirty: number, keywordsThirtyOneToForty: number, keywordsFortyOneToFifty: number, keywordsFiftyOneToSixty: number, keywordsSixtyOneToSeventy: number, keywordsSeventyOneToEighty: number, keywordsEightyOneToNinety: number, keywordsNinetyOneAndUp: number }> | null, organicVisitors?: Array<{ __typename?: 'TrafficAndLeadsDataPoints', date: any, count?: number | null }> | null } };

export type BacklinkOverviewReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
  weeksAgo?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BacklinkOverviewReportQuery = { __typename?: 'Query', backlinkOverviewReport: Array<{ __typename?: 'WpBlogBacklinkOverview', authorityScore: number, referringDomains: number, date: any }> };

export type SitesQueryVariables = Exact<{ [key: string]: never; }>;


export type SitesQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', id: number, accountId?: number | null, accountName?: string | null, platformSiteId: number, name?: string | null, targetLeadType?: string | null, subdomain?: string | null, mappedDomain?: string | null }> };

export type SitesVisitorsQueryVariables = Exact<{
  days: Scalars['Int']['input'];
}>;


export type SitesVisitorsQuery = { __typename?: 'Query', siteDashboardVisitor: { __typename?: 'SiteDashboardVisitor', visitorTotalPerSite: Array<{ __typename?: 'TotalVisitorsPerSite', subdomain?: string | null, visitors?: number | null, previousVisitors?: number | null }> } };

export type AccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: number, name: string, onboardingStatus?: OnboardingStatus | null }> };

export type RelatedKeywordsQueryVariables = Exact<{
  reportType: Report;
  searchTerm: Scalars['String']['input'];
  phraseSearchType?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RelatedKeywordsQuery = { __typename?: 'Query', keywordReport?: { __typename?: 'KeywordReport', reportType: Report, searchTerm: string, phraseSearchType?: string | null, orderBy?: string | null, sortOrder?: string | null, page?: number | null, hasMoreResults?: boolean | null, keywordOverviews?: Array<{ __typename?: 'KeywordOverviews', difficulty?: number | null, phrase: string, volume: number, position?: number | null, traffic?: number | null, url?: string | null }> | null } | null };

export type MembershipEditorQueryVariables = Exact<{
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MembershipEditorQuery = { __typename?: 'Query', membershipEditor?: Array<{ __typename?: 'MembershipEditor', selected: boolean, quantity: number, available: boolean, availabilityErrors: Array<string>, maximum?: number | null, minimum?: number | null, minimumErrors: Array<string>, product: { __typename?: 'Product', id: number, name: string, starter?: boolean | null, group?: string | null }, annualPrice: { __typename?: 'Price', id: number, amount: number, interval?: string | null, listTitle?: string | null, marketingList?: Array<string> | null, annualSavings: number, monthlyPrice: number }, monthlyPrice: { __typename?: 'Price', id: number, amount: number, interval?: string | null, listTitle?: string | null, marketingList?: Array<string> | null } }> | null };

export type OnboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingQuery = { __typename?: 'Query', onboarding: { __typename?: 'Onboarding', collaboration?: string | null, companyAddress?: string | null, companyCity?: string | null, companyName?: string | null, companyPhone?: string | null, companyState?: string | null, companyZip?: string | null, experience?: string | null, primaryIndustry?: string | null, primaryIndustries: Array<string>, primaryIndustryFocus?: string | null, primaryIndustryFocuses: any, reference?: string | null, referenceDetails?: string | null } };

export type OnboardingUpdateMutationVariables = Exact<{
  input: OnboardingUpdateInput;
}>;


export type OnboardingUpdateMutation = { __typename?: 'Mutation', onboardingUpdate?: { __typename?: 'OnboardingUpdatePayload', success: boolean, errors: Array<{ __typename?: 'UserInputError', message: string, path?: Array<string> | null }> } | null };

export type RegeneratePalettesMutationVariables = Exact<{
  input: RegeneratePalettesInput;
}>;


export type RegeneratePalettesMutation = { __typename?: 'Mutation', siteDesignRegeneratePalettes?: { __typename?: 'RegeneratePalettesPayload', errors: Array<string> } | null };

export type SaveBrandingMutationVariables = Exact<{
  input: SaveBrandingInput;
}>;


export type SaveBrandingMutation = { __typename?: 'Mutation', siteDesignSaveBranding?: { __typename?: 'SaveBrandingPayload', errors: Array<string>, siteDesign?: { __typename?: 'SiteDesign', id: number } | null } | null };

export type BusinessOnboardingQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type BusinessOnboardingQuery = { __typename?: 'Query', account: { __typename?: 'Account', businessOnboarding?: { __typename?: 'BusinessOnboarding', addressCity?: string | null, aiGeneratedAddressCity: boolean, addressState?: string | null, aiGeneratedAddressState: boolean, addressStreet?: string | null, aiGeneratedAddressStreet: boolean, addressZip?: string | null, aiGeneratedAddressZip: boolean, budgetBand?: string | null, businessName?: string | null, ownerName?: string | null, aiGeneratedOwnerName: boolean, phone?: string | null, aiGeneratedPhone: boolean, siteName?: string | null, aiGeneratedSiteName: boolean } | null } };

export type UpsertBusinessOnboardingMutationVariables = Exact<{
  input: UpsertBusinessOnboardingInput;
}>;


export type UpsertBusinessOnboardingMutation = { __typename?: 'Mutation', upsertBusinessOnboarding?: { __typename?: 'UpsertBusinessOnboardingPayload', success: boolean, errors: Array<{ __typename?: 'UserInputError', message: string, path?: Array<string> | null }> } | null };

export type MarketingStrategiesQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type MarketingStrategiesQuery = { __typename?: 'Query', account: { __typename?: 'Account', marketingStrategies: Array<{ __typename?: 'MarketingStrategy', id: number, accountId: number, status: MarketingStrategyStatus, mission?: string | null, aiGeneratedMission: boolean, startReason?: string | null, successStories: Array<string>, successMetrics: Array<string>, problemSolved?: string | null, uniquePromise?: string | null, idealClient?: string | null, serviceAreas: Array<string>, credentials: Array<string>, tone: Array<string>, externalSite?: string | null, nationwide?: boolean | null, businessText?: string | null, generationError?: string | null, crawlError?: string | null, crawlActorId?: string | null, crawlDatasetId?: string | null, backgroundWorkerId?: string | null, customerSummary?: string | null, aiTargetLeadType?: any | null, previewSessionId?: string | null, previewError?: string | null, seoStrategy?: { __typename?: 'SeoStrategy', customerSummary?: string | null, aiKeywordResearch: any, aiTargetKeywords: any } | null, contentStrategy?: { __typename?: 'ContentStrategy', contentStrategySummary?: string | null } | null, siteDesign?: { __typename?: 'SiteDesign', id: number, aiPalettes: Array<{ __typename?: 'Palette', id: string, label: string, colors: { __typename?: 'PaletteColors', carrotColorBase1: string, carrotColorBase2: string, carrotColorAccent1: string, carrotColorAccent2: string, carrotColorAccent3: string, carrotColorAccent4: string, carrotColorContrast1: string, carrotColorContrast2: string } }>, logoCandidates: Array<{ __typename?: 'LogoCandidate', url: string }> } | null }> } };

export type UpsertMarketingStrategyMutationVariables = Exact<{
  input: UpsertMarketingStrategyInput;
}>;


export type UpsertMarketingStrategyMutation = { __typename?: 'Mutation', upsertMarketingStrategy?: { __typename?: 'UpsertMarketingStrategyPayload', marketingStrategy?: { __typename?: 'MarketingStrategy', id: number } | null } | null };

export type CreateAndChargeBundleInvoiceMutationVariables = Exact<{
  input: CreateAndChargeBundleInvoiceInput;
}>;


export type CreateAndChargeBundleInvoiceMutation = { __typename?: 'Mutation', createAndChargeBundleInvoice?: { __typename?: 'CreateAndChargeBundleInvoicePayload', success: boolean, errors?: { __typename?: 'Error', type?: string | null, message?: string | null } | null } | null };

export type CreateAccountMutationVariables = Exact<{
  input: AccountCreationInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'AccountCreationPayload', user?: { __typename?: 'AccountCreated', accountId: number, jwt?: string | null } | null, errors: Array<{ __typename?: 'UserInputError', code?: string | null, path?: Array<string> | null, message: string }> } | null };

export type BundleQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type BundleQuery = { __typename?: 'Query', bundle?: { __typename?: 'Bundle', id: number, title: string, subtitle?: string | null, total: string, imageUrl?: string | null, slug: string, confirmationUrl: string, customerType?: string | null, interval?: string | null, upsertsSubscription: boolean, bundleMarketingLineItems: Array<{ __typename?: 'BundleMarketingLineItem', description?: string | null }> } | null };

export type StripeBundleCheckoutMutationVariables = Exact<{
  input: StripeBundleCheckoutInput;
}>;


export type StripeBundleCheckoutMutation = { __typename?: 'Mutation', stripeBundleCheckout?: { __typename?: 'StripeBundleCheckoutPayload', checkoutUrl?: string | null } | null };

export type SearchPerformanceQueryVariables = Exact<{
  days: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  platformSiteId: Scalars['Int']['input'];
}>;


export type SearchPerformanceQuery = { __typename?: 'Query', searchPerformanceHistory?: { __typename?: 'SearchPerformanceHistory', data?: Array<{ __typename?: 'SearchPerformanceHistoryInstance', ctr: number, clicks: number, impressions: number, position: number, date: any }> | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null, searchPerformancePageUrl?: { __typename?: 'SearchPerformancePageUrl', data?: Array<{ __typename?: 'SearchPerformancePageUrlInstance', ctr: number, clicks: number, impressions: number, position: number, pageUrl: string }> | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null, searchPerformanceQueryString?: { __typename?: 'SearchPerformanceQueryString', data?: Array<{ __typename?: 'SearchPerformanceQueryStringInstance', ctr: number, clicks: number, impressions: number, position: number, queryString: string }> | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null };

export type ConsentUrlQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
}>;


export type ConsentUrlQuery = { __typename?: 'Query', searchPerformanceConsentUrl?: { __typename?: 'SearchPerformanceConsentUrl', consentUrl?: string | null, error?: { __typename?: 'ErrorDetail', type?: string | null, message?: string | null } | null } | null };

export type StripeSubscriptionCheckoutMutationVariables = Exact<{
  input: StripeSubscriptionCheckoutInput;
}>;


export type StripeSubscriptionCheckoutMutation = { __typename?: 'Mutation', stripeSubscriptionCheckout?: { __typename?: 'StripeSubscriptionCheckoutPayload', checkoutUrl?: string | null } | null };

export type MembershipBuilderQueryVariables = Exact<{
  priceActive?: InputMaybe<Scalars['Boolean']['input']>;
  priceVersion?: InputMaybe<Scalars['Int']['input']>;
  webProductNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  crmProductNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MembershipBuilderQuery = { __typename?: 'Query', webProducts: Array<{ __typename?: 'Product', id: number, name: string, starter?: boolean | null, prices: Array<{ __typename?: 'Price', id: number, subtitle?: string | null, amount: number, interval?: string | null, listTitle?: string | null, marketingList?: Array<string> | null, lookupKey?: string | null }> }>, crmProducts: Array<{ __typename?: 'Product', id: number, name: string, prices: Array<{ __typename?: 'Price', id: number, amount: number, interval?: string | null, lookupKey?: string | null }> }> };

export type AccountSitesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AccountSitesQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: number, sites?: Array<{ __typename?: 'Site', id: number, name?: string | null, platformSiteId: number, mappedDomain?: string | null, subdomain?: string | null, actionItems: Array<{ __typename?: 'ActionItem', id: number, title: string, description?: string | null, actionUrl?: string | null, status: string, createdAt: string, priority: ActionItemPriority, isDismissible: boolean, actionType?: string | null }> }> | null } };

export type ActionItemDismissMutationVariables = Exact<{
  actionItemId: Scalars['Int']['input'];
}>;


export type ActionItemDismissMutation = { __typename?: 'Mutation', actionItemDismiss?: { __typename?: 'ActionItemDismissPayload', actionItem?: { __typename?: 'ActionItem', id: number, status: string } | null } | null };

export type SiteAuditReportIssueDetailsQueryVariables = Exact<{
  issueId: Scalars['Int']['input'];
  auditSnapshotId: Scalars['Int']['input'];
}>;


export type SiteAuditReportIssueDetailsQuery = { __typename?: 'Query', siteAuditReportIssueDetails?: { __typename?: 'AuditSnapshot', formattedErrors: Array<(
      { __typename?: 'AuditSnapshotFormattedIssue' }
      & { ' $fragmentRefs'?: { 'FormattedIssueWithDetailsFragment': FormattedIssueWithDetailsFragment } }
    )>, formattedWarnings: Array<(
      { __typename?: 'AuditSnapshotFormattedIssue' }
      & { ' $fragmentRefs'?: { 'FormattedIssueWithDetailsFragment': FormattedIssueWithDetailsFragment } }
    )>, formattedNotices: Array<(
      { __typename?: 'AuditSnapshotFormattedIssue' }
      & { ' $fragmentRefs'?: { 'FormattedIssueWithDetailsFragment': FormattedIssueWithDetailsFragment } }
    )> } | null };

export type FormattedIssueWithDetailsFragment = { __typename?: 'AuditSnapshotFormattedIssue', issueId: string, title: string, titlePage: string, urlColumn: string, infoColumn: string, details: Array<{ __typename?: 'AuditSnapshotFormattedIssueDetail', title: string, discovered: string, sourceUrl: string, targetUrl?: string | null, info?: any | null }> } & { ' $fragmentName'?: 'FormattedIssueWithDetailsFragment' };

export type SiteAuditReportQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
}>;


export type SiteAuditReportQuery = { __typename?: 'Query', siteAuditReport?: { __typename?: 'SiteAuditReport', auditSnapshot?: (
      { __typename?: 'AuditSnapshot', id: number }
      & { ' $fragmentRefs'?: { 'AuditSnapshotFragment': AuditSnapshotFragment } }
    ) | null, auditCampaign?: { __typename?: 'AuditCampaign', lastAudit?: string | null } | null } | null };

export type InitiateAuditMutationVariables = Exact<{
  input: InitiateAuditInput;
}>;


export type InitiateAuditMutation = { __typename?: 'Mutation', initiateAudit?: { __typename?: 'InitiateAuditPayload', success: boolean, errorMessage?: string | null } | null };

export type AuditSnapshotFragment = { __typename?: 'AuditSnapshot', formattedNotices: Array<(
    { __typename?: 'AuditSnapshotFormattedIssue' }
    & { ' $fragmentRefs'?: { 'FormattedIssueFragment': FormattedIssueFragment } }
  )>, formattedWarnings: Array<(
    { __typename?: 'AuditSnapshotFormattedIssue' }
    & { ' $fragmentRefs'?: { 'FormattedIssueFragment': FormattedIssueFragment } }
  )>, formattedErrors: Array<(
    { __typename?: 'AuditSnapshotFormattedIssue' }
    & { ' $fragmentRefs'?: { 'FormattedIssueFragment': FormattedIssueFragment } }
  )> } & { ' $fragmentName'?: 'AuditSnapshotFragment' };

export type FormattedIssueFragment = { __typename: 'AuditSnapshotFormattedIssue', issueId: string, titlePage: string } & { ' $fragmentName'?: 'FormattedIssueFragment' };

export type SiteDeactivateMutationVariables = Exact<{
  input: SiteDeactivateInput;
}>;


export type SiteDeactivateMutation = { __typename?: 'Mutation', siteDeactivate?: { __typename?: 'SiteDeactivatePayload', errors: Array<string> } | null };

export type DeleteMarketingStrategyMutationVariables = Exact<{
  input: DeleteMarketingStrategyInput;
}>;


export type DeleteMarketingStrategyMutation = { __typename?: 'Mutation', deleteMarketingStrategy?: { __typename?: 'DeleteMarketingStrategyPayload', success: boolean } | null };

export type SiteSettingsGscStatusQueryVariables = Exact<{
  platformSiteId: Scalars['Int']['input'];
}>;


export type SiteSettingsGscStatusQuery = { __typename?: 'Query', site?: { __typename?: 'Site', googleSiteVerification?: { __typename?: 'GoogleSiteVerification', verificationStatus?: string | null, verifiedAt?: string | null } | null } | null };

export type CreateUpcomingInvoiceMutationVariables = Exact<{
  input: CreateUpcomingInvoiceInput;
}>;


export type CreateUpcomingInvoiceMutation = { __typename?: 'Mutation', createUpcomingInvoice?: { __typename?: 'CreateUpcomingInvoicePayload', upcomingInvoice?: { __typename?: 'UpcomingInvoicePreview', invoice: { __typename?: 'StripeInvoice', tax?: number | null, total: number, periodStart?: string | null }, lineItems: Array<{ __typename?: 'StripeInvoiceLineItem', amount: number, quantity: number, price: { __typename?: 'Price', id: number, active: boolean, customerType?: string | null, interval?: string | null, product: { __typename?: 'Product', name: string, starter?: boolean | null, group?: string | null } } }> } | null, discount?: { __typename?: 'PaySubscriptionDiscount', endDate?: number | null, startDate: number, coupon: { __typename?: 'Coupon', name?: string | null, duration?: string | null, percentOff?: number | null, amountOff?: number | null } } | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type PriceByLookupKeyQueryVariables = Exact<{
  lookupKey: Scalars['String']['input'];
}>;


export type PriceByLookupKeyQuery = { __typename?: 'Query', price?: { __typename?: 'Price', id: number, product: { __typename?: 'Product', group?: string | null } } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription?: { __typename?: 'UpdateSubscriptionPayload', portalUrl: string, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type SubscriptionUpdateStatusQueryVariables = Exact<{
  wordpressUserId: Scalars['Int']['input'];
}>;


export type SubscriptionUpdateStatusQuery = { __typename?: 'Query', user?: { __typename?: 'User', currentSubscription?: { __typename?: 'PaySubscription', pendingUpdate: boolean } | null } | null };

export type ActionItemTemplatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionItemTemplatesListQuery = { __typename?: 'Query', actionItemTemplates: Array<{ __typename?: 'ActionItemTemplate', id: number, actionType: string, title: string, priority: ActionItemPriority, trigger: ActionItemTrigger, isActive: boolean }> };

export type ActionItemTemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ActionItemTemplateQuery = { __typename?: 'Query', actionItemTemplate?: { __typename?: 'ActionItemTemplate', id: number, actionType: string, title: string, description?: string | null, priority: ActionItemPriority, trigger: ActionItemTrigger, isDismissible: boolean, isActive: boolean, actionUrlTemplate?: string | null } | null };

export type UpsertActionItemTemplateMutationVariables = Exact<{
  input: ActionItemTemplateUpsertInput;
}>;


export type UpsertActionItemTemplateMutation = { __typename?: 'Mutation', upsertActionItemTemplate?: { __typename?: 'ActionItemTemplateUpsertPayload', actionItemTemplate?: { __typename?: 'ActionItemTemplate', id: number } | null } | null };

export type CreateBundleDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateBundleDataQuery = { __typename?: 'Query', coupons: Array<{ __typename?: 'Coupon', name?: string | null, processorId?: string | null, id: number, amountOff?: number | null, percentOff?: number | null, duration?: string | null, durationInMonths?: number | null }>, prices: Array<{ __typename?: 'Price', interval?: string | null, amount: number, id: number, stripeId?: string | null, product: { __typename?: 'Product', name: string } }> };

export type CreateBundleMutationVariables = Exact<{
  input: CreateBundleInput;
}>;


export type CreateBundleMutation = { __typename?: 'Mutation', createBundle?: { __typename?: 'CreateBundlePayload', error?: string | null } | null };

export type BundlesQueryVariables = Exact<{ [key: string]: never; }>;


export type BundlesQuery = { __typename?: 'Query', bundles: Array<{ __typename?: 'Bundle', confirmationUrl: string, id: number, imageUrl?: string | null, slug: string, subtitle?: string | null, title: string, total: string, upsertsSubscription: boolean, bundleMarketingLineItems: Array<{ __typename?: 'BundleMarketingLineItem', description?: string | null }> }> };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: number, name: string, stripeId?: string | null }> };

export type UpsertFeatureMutationVariables = Exact<{
  input: UpsertFeatureInput;
}>;


export type UpsertFeatureMutation = { __typename?: 'Mutation', upsertFeature?: { __typename?: 'UpsertFeaturePayload', feature: { __typename?: 'Feature', id: number } } | null };

export type DeleteFeatureMutationVariables = Exact<{
  input: DeleteFeatureInput;
}>;


export type DeleteFeatureMutation = { __typename?: 'Mutation', deleteFeature?: { __typename?: 'DeleteFeaturePayload', success: boolean } | null };

export type FeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesQuery = { __typename?: 'Query', features?: Array<{ __typename?: 'Feature', id: number, name: string, slug: string, productFeatures: Array<{ __typename?: 'ProductFeature', id: number, units?: number | null, product: { __typename?: 'Product', id: number, name: string, stripeId?: string | null } }> }> | null };

export type ProductDetailQueryVariables = Exact<{
  stripeId: Scalars['String']['input'];
}>;


export type ProductDetailQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: number, name: string, stripeId?: string | null, description?: string | null, group?: string | null, active?: boolean | null, productFeatures: Array<{ __typename?: 'ProductFeature', id: number, units?: number | null, feature: { __typename?: 'Feature', id: number, name: string, slug: string } }> } | null };

export type ProductsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsListQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: number, name: string, stripeId?: string | null, features: Array<{ __typename?: 'Feature', id: number }> }> };

export type UpdateActiveAccountMutationVariables = Exact<{
  input: ActiveAccountUpdateInput;
}>;


export type UpdateActiveAccountMutation = { __typename?: 'Mutation', activeAccountUpdate?: { __typename?: 'ActiveAccountUpdatePayload', errors?: Array<string> | null, activeAccount?: { __typename?: 'Account', id: number, owner: { __typename?: 'User', carrotVersion?: number | null } } | null } | null };

export type TeamMemberAcceptInviteMutationVariables = Exact<{
  input: TeamMemberAcceptInviteInput;
}>;


export type TeamMemberAcceptInviteMutation = { __typename?: 'Mutation', teamMemberAcceptInvite?: { __typename?: 'TeamMemberAcceptInvitePayload', success: boolean, errors: Array<string>, account?: { __typename?: 'Account', name: string, isAgency: boolean } | null } | null };

export type EditTeamMemberMutationVariables = Exact<{
  input: TeamMemberEditInput;
}>;


export type EditTeamMemberMutation = { __typename?: 'Mutation', teamMemberEdit?: { __typename?: 'TeamMemberEditPayload', teamMember?: (
      { __typename?: 'TeamMember' }
      & { ' $fragmentRefs'?: { 'TeamMemberFragment': TeamMemberFragment } }
    ) | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type DeleteTeamMemberMutationVariables = Exact<{
  input: TeamMemberDeleteInput;
}>;


export type DeleteTeamMemberMutation = { __typename?: 'Mutation', teamMemberDelete?: { __typename?: 'TeamMemberDeletePayload', success?: boolean | null, errors: Array<string> } | null };

export type InviteTeamMemberMutationVariables = Exact<{
  input: TeamMemberAddToAccountInput;
}>;


export type InviteTeamMemberMutation = { __typename?: 'Mutation', teamMemberAddToAccount?: { __typename?: 'TeamMemberAddToAccountPayload', teamMember?: (
      { __typename?: 'TeamMember' }
      & { ' $fragmentRefs'?: { 'TeamMemberFragment': TeamMemberFragment } }
    ) | null, errors: Array<{ __typename?: 'UserInputError', path?: Array<string> | null, message: string }> } | null };

export type TeamMembersQueryVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;


export type TeamMembersQuery = { __typename?: 'Query', account: { __typename?: 'Account', teamMembers?: Array<(
      { __typename?: 'TeamMember', id: number }
      & { ' $fragmentRefs'?: { 'TeamMemberFragment': TeamMemberFragment } }
    )> | null } };

export type TeamMemberFragment = { __typename: 'TeamMember', id: number, accountRole: string, crmSeat: boolean, inviteEmail: string, pending: boolean, blogRoles: Array<{ __typename?: 'TeamMemberBlogRole', siteId: number, role: TeamMemberBlogRoleValue }>, user?: { __typename?: 'User', id: number, name?: string | null, email: string } | null } & { ' $fragmentName'?: 'TeamMemberFragment' };

export const FormattedIssueWithDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssueWithDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}},{"kind":"Field","name":{"kind":"Name","value":"urlColumn"}},{"kind":"Field","name":{"kind":"Name","value":"infoColumn"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]} as unknown as DocumentNode<FormattedIssueWithDetailsFragment, unknown>;
export const FormattedIssueFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}}]}}]} as unknown as DocumentNode<FormattedIssueFragment, unknown>;
export const AuditSnapshotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuditSnapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}}]}}]} as unknown as DocumentNode<AuditSnapshotFragment, unknown>;
export const TeamMemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<TeamMemberFragment, unknown>;
export const HubspotTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hubspotToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hubspotToken"}}]}}]} as unknown as DocumentNode<HubspotTokenQuery, HubspotTokenQueryVariables>;
export const AmGraphQlTestQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"amGraphQlTestQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}}]} as unknown as DocumentNode<AmGraphQlTestQueryQuery, AmGraphQlTestQueryQueryVariables>;
export const AmInfiniteTestQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"amInfiniteTestQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceTitle"}}]}}]}}]} as unknown as DocumentNode<AmInfiniteTestQueryQuery, AmInfiniteTestQueryQueryVariables>;
export const AmGraphQlTestMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"amGraphQlTestMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeCustomerPortalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerPortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<AmGraphQlTestMutationMutation, AmGraphQlTestMutationMutationVariables>;
export const SiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"site"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"blockTheme"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"marketingStrategyId"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordpressUserId"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUsername"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googleAuthConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"semrushProviderProjectId"}}]}}]}}]} as unknown as DocumentNode<SiteQuery, SiteQueryVariables>;
export const AccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"account"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAgency"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrotAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"carrotCrmConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paySubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usage"}},{"kind":"Field","name":{"kind":"Name","value":"limits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"platformSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"registeredAt"}},{"kind":"Field","name":{"kind":"Name","value":"blockTheme"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wordpressUserId"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUsername"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AccountQuery, AccountQueryVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"carrotAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"carrotCrmConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAgency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrotAccountStatus"}},{"kind":"Field","name":{"kind":"Name","value":"carrotVersion"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardOptInState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUserId"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressUsername"}},{"kind":"Field","name":{"kind":"Name","value":"superAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"vip"}},{"kind":"Field","name":{"kind":"Name","value":"currentSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"pastDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"pastDueCancelAtDate"}},{"kind":"Field","name":{"kind":"Name","value":"pendingCancellation"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"starter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressLabel"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressLabel"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const StripeCustomerPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeCustomerPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeCustomerPortalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerPortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<StripeCustomerPortalMutation, StripeCustomerPortalMutationVariables>;
export const TeamMemberAbilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamMemberAbilities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberAbility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"limitingIds"}}]}}]}}]} as unknown as DocumentNode<TeamMemberAbilitiesQuery, TeamMemberAbilitiesQueryVariables>;
export const AgencyClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"agencyClients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyClientAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}}]}}]}}]}}]} as unknown as DocumentNode<AgencyClientsQuery, AgencyClientsQueryVariables>;
export const AgencyAddClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"agencyAddClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddClientInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agencyAddClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]} as unknown as DocumentNode<AgencyAddClientMutation, AgencyAddClientMutationVariables>;
export const TrafficAndLeadsReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"trafficAndLeadsReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trafficAndLeadsReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitorsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"visitorsTotalChange"}},{"kind":"Field","name":{"kind":"Name","value":"leadsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"leadsTotalChange"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRateChange"}},{"kind":"Field","name":{"kind":"Name","value":"avgSessionTime"}},{"kind":"Field","name":{"kind":"Name","value":"avgSessionTimeChange"}},{"kind":"Field","name":{"kind":"Name","value":"mobileUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TrafficAndLeadsReportQuery, TrafficAndLeadsReportQueryVariables>;
export const LandingPageReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"landingPageReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPageReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"landingPage"}},{"kind":"Field","name":{"kind":"Name","value":"visitors"}},{"kind":"Field","name":{"kind":"Name","value":"pageViewsPerVisitor"}},{"kind":"Field","name":{"kind":"Name","value":"avgEngagementTimePerSession"}},{"kind":"Field","name":{"kind":"Name","value":"conversions"}},{"kind":"Field","name":{"kind":"Name","value":"conversionRate"}}]}}]}}]} as unknown as DocumentNode<LandingPageReportQuery, LandingPageReportQueryVariables>;
export const TrafficSourceReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"trafficSourceReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trafficSourceReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"visitors"}}]}}]}}]} as unknown as DocumentNode<TrafficSourceReportQuery, TrafficSourceReportQueryVariables>;
export const BacklinkAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkProfileReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomains"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalChange"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScoreChange"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainsChange"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkCategoryReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followed"}},{"kind":"Field","name":{"kind":"Name","value":"notFollowed"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"userGeneratedContent"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainTotal"}},{"kind":"Field","name":{"kind":"Name","value":"backlinkTotal"}}]}}]}}]} as unknown as DocumentNode<BacklinkAnalysisQuery, BacklinkAnalysisQueryVariables>;
export const BacklinksOverTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinksOverTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"weeksAgo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<BacklinksOverTimeQuery, BacklinksOverTimeQueryVariables>;
export const BacklinkReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageAscore"}},{"kind":"Field","name":{"kind":"Name","value":"sourceTitle"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"anchor"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"nofollow"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"sitewide"}},{"kind":"Field","name":{"kind":"Name","value":"newlink"}},{"kind":"Field","name":{"kind":"Name","value":"lostlink"}},{"kind":"Field","name":{"kind":"Name","value":"externalNum"}},{"kind":"Field","name":{"kind":"Name","value":"internalNum"}},{"kind":"Field","name":{"kind":"Name","value":"firstSeen"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}}]}}]}}]} as unknown as DocumentNode<BacklinkReportQuery, BacklinkReportQueryVariables>;
export const BacklinkUpsellReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkUpsellReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteBacklinkUpsellReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"backlinks"}}]}}]}}]} as unknown as DocumentNode<BacklinkUpsellReportQuery, BacklinkUpsellReportQueryVariables>;
export const MembershipManagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membershipManagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipManagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"customerPortalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"cancellationRequestLink"}},{"kind":"Field","name":{"kind":"Name","value":"paySubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"limits"}},{"kind":"Field","name":{"kind":"Name","value":"usage"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"payPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"billingDetails"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipManagementQuery, MembershipManagementQueryVariables>;
export const SubscriptionInvoicePreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subscriptionInvoicePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionInvoicePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subscriptionType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscriptionType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionInvoicePreviewQuery, SubscriptionInvoicePreviewQueryVariables>;
export const CancelSubscriptionAtPeriodEndDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelSubscriptionAtPeriodEnd"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CancelSubscriptionAtPeriodEndInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelSubscriptionAtPeriodEnd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CancelSubscriptionAtPeriodEndMutation, CancelSubscriptionAtPeriodEndMutationVariables>;
export const ToggleBlockedNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"toggleBlockedNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ToggleBlockedNumberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleBlockedNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ToggleBlockedNumberMutation, ToggleBlockedNumberMutationVariables>;
export const SiteEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"siteEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformSiteId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SiteEditMutation, SiteEditMutationVariables>;
export const CampaignEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"campaignEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CampaignEditMutation, CampaignEditMutationVariables>;
export const TwilioSubaccountCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"twilioSubaccountCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TwilioSubaccountCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccountCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TwilioSubaccountCreateMutation, TwilioSubaccountCreateMutationVariables>;
export const AvailableNumbersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"availableNumbers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availablePhoneNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"areaCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}}]}}]} as unknown as DocumentNode<AvailableNumbersQuery, AvailableNumbersQueryVariables>;
export const BuyPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"buyPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumberBuyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyPhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BuyPhoneNumberMutation, BuyPhoneNumberMutationVariables>;
export const SearchCodeSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchCodeSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codeType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchCodeSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"codeType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codeType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areaCodes"}},{"kind":"Field","name":{"kind":"Name","value":"zipCodes"}}]}}]}}]} as unknown as DocumentNode<SearchCodeSuggestionsQuery, SearchCodeSuggestionsQueryVariables>;
export const PhoneNumberDestroyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"phoneNumberDestroy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumberDestroyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumberDestroy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PhoneNumberDestroyMutation, PhoneNumberDestroyMutationVariables>;
export const CallTrackingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"callTracking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"site"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platformSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"twilioSubaccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callTrackingNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"campaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"forwardToNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"region"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"callStatus"}},{"kind":"Field","name":{"kind":"Name","value":"fromNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toNumber"}},{"kind":"Field","name":{"kind":"Name","value":"durationInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"callScore"}},{"kind":"Field","name":{"kind":"Name","value":"callScoreReasoning"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"actionItems"}},{"kind":"Field","name":{"kind":"Name","value":"crmOpportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"spam"}}]}},{"kind":"Field","name":{"kind":"Name","value":"texts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"receivedTime"}},{"kind":"Field","name":{"kind":"Name","value":"fromNumber"}},{"kind":"Field","name":{"kind":"Name","value":"toNumber"}},{"kind":"Field","name":{"kind":"Name","value":"crmOpportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"spam"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CallTrackingQuery, CallTrackingQueryVariables>;
export const PhoneNumberEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"phoneNumberEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PhoneNumberEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumberEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PhoneNumberEditMutation, PhoneNumberEditMutationVariables>;
export const SubmitCancellationSurveyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"submitCancellationSurvey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitCancellationSurveyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitCancellationSurvey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"posthogSurveyId"}},{"kind":"Field","name":{"kind":"Name","value":"refundEligible"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCategory"}},{"kind":"Field","name":{"kind":"Name","value":"productBeingCanceled"}},{"kind":"Field","name":{"kind":"Name","value":"offerAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"finalOutcome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retentionOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"pauseDurationMonths"}},{"kind":"Field","name":{"kind":"Name","value":"targetProductSlug"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercent"}},{"kind":"Field","name":{"kind":"Name","value":"durationMonths"}},{"kind":"Field","name":{"kind":"Name","value":"couponProcessorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitCancellationSurveyMutation, SubmitCancellationSurveyMutationVariables>;
export const PauseSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pauseSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PauseSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pauseSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offerAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"finalOutcome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;
export const PauseStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"pauseStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipManagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paySubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PauseStatusQuery, PauseStatusQueryVariables>;
export const LatestInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"latestInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"wordpressLabel"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LatestInvoiceQuery, LatestInvoiceQueryVariables>;
export const DomainOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"domainOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkProfileReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomains"}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalChange"}},{"kind":"Field","name":{"kind":"Name","value":"authorityScoreChange"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainsChange"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"backlinkCategoryReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"followed"}},{"kind":"Field","name":{"kind":"Name","value":"notFollowed"}},{"kind":"Field","name":{"kind":"Name","value":"sponsored"}},{"kind":"Field","name":{"kind":"Name","value":"userGeneratedContent"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"form"}},{"kind":"Field","name":{"kind":"Name","value":"frame"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomainTotal"}},{"kind":"Field","name":{"kind":"Name","value":"backlinkTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organicProfileReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsChange"}},{"kind":"Field","name":{"kind":"Name","value":"organicVisitors"}},{"kind":"Field","name":{"kind":"Name","value":"organicVisitorsChange"}}]}}]}}]} as unknown as DocumentNode<DomainOverviewQuery, DomainOverviewQueryVariables>;
export const OrganicOverviewReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organicOverviewReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organicOverviewReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"weeksAgo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domainOverviewHistories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsOneToThree"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsFourToTen"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsElevenToTwenty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsTwentyOneToThirty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsThirtyOneToForty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsFortyOneToFifty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsFiftyOneToSixty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsSixtyOneToSeventy"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsSeventyOneToEighty"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsEightyOneToNinety"}},{"kind":"Field","name":{"kind":"Name","value":"keywordsNinetyOneAndUp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organicVisitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<OrganicOverviewReportQuery, OrganicOverviewReportQueryVariables>;
export const BacklinkOverviewReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"backlinkOverviewReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backlinkOverviewReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"weeksAgo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeksAgo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorityScore"}},{"kind":"Field","name":{"kind":"Name","value":"referringDomains"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<BacklinkOverviewReportQuery, BacklinkOverviewReportQueryVariables>;
export const SitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"platformSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"targetLeadType"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}}]}}]}}]} as unknown as DocumentNode<SitesQuery, SitesQueryVariables>;
export const SitesVisitorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sitesVisitors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDashboardVisitor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitorTotalPerSite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"visitors"}},{"kind":"Field","name":{"kind":"Name","value":"previousVisitors"}}]}}]}}]}}]} as unknown as DocumentNode<SitesVisitorsQuery, SitesVisitorsQueryVariables>;
export const AccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingStatus"}}]}}]}}]} as unknown as DocumentNode<AccountsQuery, AccountsQueryVariables>;
export const RelatedKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"relatedKeywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phraseSearchType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywordReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportType"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}},{"kind":"Argument","name":{"kind":"Name","value":"phraseSearchType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phraseSearchType"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportType"}},{"kind":"Field","name":{"kind":"Name","value":"searchTerm"}},{"kind":"Field","name":{"kind":"Name","value":"phraseSearchType"}},{"kind":"Field","name":{"kind":"Name","value":"orderBy"}},{"kind":"Field","name":{"kind":"Name","value":"sortOrder"}},{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"hasMoreResults"}},{"kind":"Field","name":{"kind":"Name","value":"keywordOverviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"difficulty"}},{"kind":"Field","name":{"kind":"Name","value":"phrase"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"traffic"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<RelatedKeywordsQuery, RelatedKeywordsQueryVariables>;
export const MembershipEditorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membershipEditor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipEditor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selected"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityErrors"}},{"kind":"Field","name":{"kind":"Name","value":"maximum"}},{"kind":"Field","name":{"kind":"Name","value":"minimum"}},{"kind":"Field","name":{"kind":"Name","value":"minimumErrors"}},{"kind":"Field","name":{"kind":"Name","value":"annualPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"listTitle"}},{"kind":"Field","name":{"kind":"Name","value":"marketingList"}},{"kind":"Field","name":{"kind":"Name","value":"annualSavings"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"monthlyPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"listTitle"}},{"kind":"Field","name":{"kind":"Name","value":"marketingList"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipEditorQuery, MembershipEditorQueryVariables>;
export const OnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collaboration"}},{"kind":"Field","name":{"kind":"Name","value":"companyAddress"}},{"kind":"Field","name":{"kind":"Name","value":"companyCity"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"companyPhone"}},{"kind":"Field","name":{"kind":"Name","value":"companyState"}},{"kind":"Field","name":{"kind":"Name","value":"companyZip"}},{"kind":"Field","name":{"kind":"Name","value":"experience"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustry"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustries"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustryFocus"}},{"kind":"Field","name":{"kind":"Name","value":"primaryIndustryFocuses"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"referenceDetails"}}]}}]}}]} as unknown as DocumentNode<OnboardingQuery, OnboardingQueryVariables>;
export const OnboardingUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"onboardingUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardingUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboardingUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<OnboardingUpdateMutation, OnboardingUpdateMutationVariables>;
export const RegeneratePalettesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"regeneratePalettes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegeneratePalettesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDesignRegeneratePalettes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RegeneratePalettesMutation, RegeneratePalettesMutationVariables>;
export const SaveBrandingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveBranding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveBrandingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDesignSaveBranding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"siteDesign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SaveBrandingMutation, SaveBrandingMutationVariables>;
export const BusinessOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"businessOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessOnboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressCity"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedAddressCity"}},{"kind":"Field","name":{"kind":"Name","value":"addressState"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedAddressState"}},{"kind":"Field","name":{"kind":"Name","value":"addressStreet"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedAddressStreet"}},{"kind":"Field","name":{"kind":"Name","value":"addressZip"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedAddressZip"}},{"kind":"Field","name":{"kind":"Name","value":"budgetBand"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedOwnerName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedPhone"}},{"kind":"Field","name":{"kind":"Name","value":"siteName"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedSiteName"}}]}}]}}]}}]} as unknown as DocumentNode<BusinessOnboardingQuery, BusinessOnboardingQueryVariables>;
export const UpsertBusinessOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertBusinessOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertBusinessOnboardingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertBusinessOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpsertBusinessOnboardingMutation, UpsertBusinessOnboardingMutationVariables>;
export const MarketingStrategiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"marketingStrategies"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingStrategies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mission"}},{"kind":"Field","name":{"kind":"Name","value":"aiGeneratedMission"}},{"kind":"Field","name":{"kind":"Name","value":"startReason"}},{"kind":"Field","name":{"kind":"Name","value":"successStories"}},{"kind":"Field","name":{"kind":"Name","value":"successMetrics"}},{"kind":"Field","name":{"kind":"Name","value":"problemSolved"}},{"kind":"Field","name":{"kind":"Name","value":"uniquePromise"}},{"kind":"Field","name":{"kind":"Name","value":"idealClient"}},{"kind":"Field","name":{"kind":"Name","value":"serviceAreas"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"tone"}},{"kind":"Field","name":{"kind":"Name","value":"externalSite"}},{"kind":"Field","name":{"kind":"Name","value":"nationwide"}},{"kind":"Field","name":{"kind":"Name","value":"businessText"}},{"kind":"Field","name":{"kind":"Name","value":"generationError"}},{"kind":"Field","name":{"kind":"Name","value":"crawlError"}},{"kind":"Field","name":{"kind":"Name","value":"crawlActorId"}},{"kind":"Field","name":{"kind":"Name","value":"crawlDatasetId"}},{"kind":"Field","name":{"kind":"Name","value":"backgroundWorkerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerSummary"}},{"kind":"Field","name":{"kind":"Name","value":"seoStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerSummary"}},{"kind":"Field","name":{"kind":"Name","value":"aiKeywordResearch"}},{"kind":"Field","name":{"kind":"Name","value":"aiTargetKeywords"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiTargetLeadType"}},{"kind":"Field","name":{"kind":"Name","value":"contentStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentStrategySummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previewSessionId"}},{"kind":"Field","name":{"kind":"Name","value":"previewError"}},{"kind":"Field","name":{"kind":"Name","value":"siteDesign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiPalettes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrotColorBase1"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorBase2"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorAccent1"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorAccent2"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorAccent3"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorAccent4"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorContrast1"}},{"kind":"Field","name":{"kind":"Name","value":"carrotColorContrast2"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoCandidates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MarketingStrategiesQuery, MarketingStrategiesQueryVariables>;
export const UpsertMarketingStrategyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertMarketingStrategy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertMarketingStrategyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertMarketingStrategy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingStrategy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertMarketingStrategyMutation, UpsertMarketingStrategyMutationVariables>;
export const CreateAndChargeBundleInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAndChargeBundleInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAndChargeBundleInvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndChargeBundleInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAndChargeBundleInvoiceMutation, CreateAndChargeBundleInvoiceMutationVariables>;
export const CreateAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"jwt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountMutation, CreateAccountMutationVariables>;
export const BundleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bundle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"bundleMarketingLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"upsertsSubscription"}}]}}]}}]} as unknown as DocumentNode<BundleQuery, BundleQueryVariables>;
export const StripeBundleCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeBundleCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeBundleCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeBundleCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}}]}}]}}]} as unknown as DocumentNode<StripeBundleCheckoutMutation, StripeBundleCheckoutMutationVariables>;
export const SearchPerformanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchPerformance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPerformanceHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchPerformancePageUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"pageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"searchPerformanceQueryString"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctr"}},{"kind":"Field","name":{"kind":"Name","value":"clicks"}},{"kind":"Field","name":{"kind":"Name","value":"impressions"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"queryString"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SearchPerformanceQuery, SearchPerformanceQueryVariables>;
export const ConsentUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"consentUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPerformanceConsentUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ConsentUrlQuery, ConsentUrlQueryVariables>;
export const StripeSubscriptionCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"stripeSubscriptionCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StripeSubscriptionCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeSubscriptionCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutUrl"}}]}}]}}]} as unknown as DocumentNode<StripeSubscriptionCheckoutMutation, StripeSubscriptionCheckoutMutationVariables>;
export const MembershipBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"membershipBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceActive"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceVersion"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"webProductNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmProductNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"webProducts"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"webProductNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"listTitle"}},{"kind":"Field","name":{"kind":"Name","value":"marketingList"}},{"kind":"Field","name":{"kind":"Name","value":"lookupKey"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"crmProducts"},"name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmProductNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceActive"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"lookupKey"}}]}}]}}]}}]} as unknown as DocumentNode<MembershipBuilderQuery, MembershipBuilderQueryVariables>;
export const AccountSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountSites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"platformSiteId"}},{"kind":"Field","name":{"kind":"Name","value":"mappedDomain"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"actionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"actionUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"isDismissible"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountSitesQuery, AccountSitesQueryVariables>;
export const ActionItemDismissDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"actionItemDismiss"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionItemDismiss"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionItemId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ActionItemDismissMutation, ActionItemDismissMutationVariables>;
export const SiteAuditReportIssueDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteAuditReportIssueDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"auditSnapshotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteAuditReportIssueDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"auditSnapshotId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"auditSnapshotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssueWithDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssueWithDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssueWithDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssueWithDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}},{"kind":"Field","name":{"kind":"Name","value":"urlColumn"}},{"kind":"Field","name":{"kind":"Name","value":"infoColumn"}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"discovered"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"targetUrl"}},{"kind":"Field","name":{"kind":"Name","value":"info"}}]}}]}}]} as unknown as DocumentNode<SiteAuditReportIssueDetailsQuery, SiteAuditReportIssueDetailsQueryVariables>;
export const SiteAuditReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteAuditReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteAuditReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auditSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuditSnapshot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auditCampaign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastAudit"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormattedIssue"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshotFormattedIssue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"titlePage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuditSnapshot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuditSnapshot"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedWarnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormattedIssue"}}]}}]}}]} as unknown as DocumentNode<SiteAuditReportQuery, SiteAuditReportQueryVariables>;
export const InitiateAuditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateAudit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InitiateAuditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateAudit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}}]}}]}}]} as unknown as DocumentNode<InitiateAuditMutation, InitiateAuditMutationVariables>;
export const SiteDeactivateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"siteDeactivate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteDeactivateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteDeactivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SiteDeactivateMutation, SiteDeactivateMutationVariables>;
export const DeleteMarketingStrategyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteMarketingStrategy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMarketingStrategyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMarketingStrategy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteMarketingStrategyMutation, DeleteMarketingStrategyMutationVariables>;
export const SiteSettingsGscStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"siteSettingsGscStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"platformSiteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platformSiteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleSiteVerification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}}]}}]}}]} as unknown as DocumentNode<SiteSettingsGscStatusQuery, SiteSettingsGscStatusQueryVariables>;
export const CreateUpcomingInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUpcomingInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUpcomingInvoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUpcomingInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upcomingInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tax"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"customerType"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"starter"}},{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUpcomingInvoiceMutation, CreateUpcomingInvoiceMutationVariables>;
export const PriceByLookupKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"priceByLookupKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lookupKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"active"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"lookupKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lookupKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"}}]}}]}}]}}]} as unknown as DocumentNode<PriceByLookupKeyQuery, PriceByLookupKeyQueryVariables>;
export const UpdateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const SubscriptionUpdateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subscriptionUpdateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"wordpressUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wordpressUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingUpdate"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionUpdateStatusQuery, SubscriptionUpdateStatusQueryVariables>;
export const ActionItemTemplatesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionItemTemplatesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionItemTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"trigger"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<ActionItemTemplatesListQuery, ActionItemTemplatesListQueryVariables>;
export const ActionItemTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"actionItemTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionItemTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"trigger"}},{"kind":"Field","name":{"kind":"Name","value":"isDismissible"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"actionUrlTemplate"}}]}}]}}]} as unknown as DocumentNode<ActionItemTemplateQuery, ActionItemTemplateQueryVariables>;
export const UpsertActionItemTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertActionItemTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActionItemTemplateUpsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertActionItemTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionItemTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertActionItemTemplateMutation, UpsertActionItemTemplateMutationVariables>;
export const CreateBundleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"createBundleData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bundleable"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"processorId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amountOff"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"durationInMonths"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bundleable"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}}]}}]}}]} as unknown as DocumentNode<CreateBundleDataQuery, CreateBundleDataQueryVariables>;
export const CreateBundleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBundle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBundleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBundle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<CreateBundleMutation, CreateBundleMutationVariables>;
export const BundlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bundleMarketingLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"upsertsSubscription"}}]}}]}}]} as unknown as DocumentNode<BundlesQuery, BundlesQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const UpsertFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertFeatureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertFeatureMutation, UpsertFeatureMutationVariables>;
export const DeleteFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFeatureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteFeatureMutation, DeleteFeatureMutationVariables>;
export const FeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"productFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"units"}}]}}]}}]}}]} as unknown as DocumentNode<FeaturesQuery, FeaturesQueryVariables>;
export const ProductDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stripeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stripeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stripeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"productFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"units"}},{"kind":"Field","name":{"kind":"Name","value":"feature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductDetailQuery, ProductDetailQueryVariables>;
export const ProductsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productsList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripeId"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProductsListQuery, ProductsListQueryVariables>;
export const UpdateActiveAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateActiveAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ActiveAccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeAccountUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carrotVersion"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateActiveAccountMutation, UpdateActiveAccountMutationVariables>;
export const TeamMemberAcceptInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"teamMemberAcceptInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberAcceptInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberAcceptInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAgency"}}]}}]}}]}}]} as unknown as DocumentNode<TeamMemberAcceptInviteMutation, TeamMemberAcceptInviteMutationVariables>;
export const EditTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"editTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberEditInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<EditTeamMemberMutation, EditTeamMemberMutationVariables>;
export const DeleteTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamMemberMutation, DeleteTeamMemberMutationVariables>;
export const InviteTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"inviteTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberAddToAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMemberAddToAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<InviteTeamMemberMutation, InviteTeamMemberMutationVariables>;
export const TeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMember"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountRole"}},{"kind":"Field","name":{"kind":"Name","value":"crmSeat"}},{"kind":"Field","name":{"kind":"Name","value":"inviteEmail"}},{"kind":"Field","name":{"kind":"Name","value":"pending"}},{"kind":"Field","name":{"kind":"Name","value":"blogRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<TeamMembersQuery, TeamMembersQueryVariables>;